<template>
  <div class="setup-container">
    <v-btn
      id="button-save-setup"
      v-if="!isViewOnly && showStickySaveButton"
      color="success"
      size="large"
      variant="elevated"
      @click="Update"
      :loading="dialog"
      :disabled="dialog"
      prepend-icon="mdi-content-save"
      class="save-action-button sticky-save-btn"
      rounded="lg"
    >
      <template v-slot:prepend>
        <v-icon size="20">mdi-content-save</v-icon>
      </template>
      {{ $t('save') }} Configuration
    </v-btn>
    <v-container fluid class="pa-6">
      <!-- Header Section -->
      <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('general_title') }}</v-toolbar-title>
        <v-spacer />
        <div class="d-flex pr-4">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
        </div>
      </v-toolbar>

      <!-- Configuration Cards -->
      <div class="config-grid">
        <v-row v-if="!isViewOnly" justify="end" class="mt-4">
          <v-btn
            color="success"
            size="large"
            variant="elevated"
            @click="Update"
            :loading="dialog"
            :disabled="dialog"
            prepend-icon="mdi-content-save"
            class="save-action-button"
            rounded="lg"
            style="margin-right: 12px"
          >
            <template v-slot:prepend>
              <v-icon size="20">mdi-content-save</v-icon>
            </template>
            {{ $t('save') }} Configuration
          </v-btn>
        </v-row>

        <!-- GPT Configuration Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-robot</v-icon>
            <span>GPT Configuration</span>
          </v-card-title>
          <v-card-text class="card-content">
            <!-- Azure OpenAI Endpoints -->
            <div class="section-title">Azure OpenAI Endpoints</div>

            <div v-for="(item, index) in setupListAzureOpenAIEndpoint" :key="item.id" class="endpoint-card">
              <v-row no-gutters>
                <v-col cols="12" md="2">
                  <v-text-field
                    label="Priority"
                    v-model="item.priorityDisplay"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                    @keypress="isNumberpositive($event)"
                    class="priority-field"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey">mdi-sort-numeric-ascending</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="px-2">
                  <v-text-field label="Azure OpenAI URL" v-model="item.azureOpenAIUrl" :rules="[rules.required]" density="comfortable" variant="outlined">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey">mdi-link</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="px-2">
                  <v-text-field label="API Key" v-model="item.azureOpenAIAPIKey" :rules="[rules.required]" density="comfortable" variant="outlined" :type="item.showValue ? 'text' : 'password'">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey">mdi-key</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn icon size="small" variant="text" density="comfortable" @click="item.showValue = !item.showValue">
                        <v-icon size="small">{{ item.showValue ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="d-flex align-center justify-end">
                  <v-btn v-if="index !== 0" icon color="error" variant="text" density="comfortable" @click="Delete(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <v-btn outlined color="primary" @click="Add()" class="add-endpoint-btn" v-show="setupListAzureOpenAIEndpoint.length > 0">
              <v-icon location="left">mdi-plus</v-icon>
              Add Endpoint
            </v-btn>

            <!-- LLM Timeout (non-Gemini providers: Azure/OpenAI/Anthropic) -->
            <v-row class="mt-2">
              <v-col cols="12" md="3">
                <v-text-field
                  label="LLM Timeout (seconds)"
                  v-model="setup.llmTimeout"
                  density="comfortable"
                  variant="outlined"
                  type="number"
                  hint="Cut request if too slow (0 = no limit)"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-timer-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Max Retry"
                  v-model="setup.endpointSuspenseFailCount"
                  density="comfortable"
                  variant="outlined"
                  type="number"
                  hint="Retry count on failure (0 = no retry)"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-refresh</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <!-- Embedding Configuration -->
            <v-divider class="my-6"></v-divider>
            <div class="section-title">Embedding Configuration</div>

            <v-row v-show="setupListAzureOpenAIEndpoint.length > 0">
              <v-col cols="12" md="6">
                <v-text-field label="Embedding URL" v-model="setup.AzureOpenAIEmbeding_Url" :rules="[rules.required]" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-vector-triangle</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Embedding API Key"
                  v-model="setup.AzureOpenAIEmbeding_APIKey"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                  :type="setup.Show_AzureOpenAI_APIKey ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AzureOpenAI_APIKey = !setup.Show_AzureOpenAI_APIKey">
                      <v-icon small>{{ setup.Show_AzureOpenAI_APIKey ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="Embedding API Version" v-model="setup.AzureOpenAIEmbeding_APIVersion" :rules="[rules.required]" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-version</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  id="embedingType-setup"
                  label="Embedding Type"
                  :items="azureOpenAI_EmbedingType_List"
                  item-title="text"
                  item-value="value"
                  v-model="setup.AzureOpenAI_EmbedingType"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-format-list-bulleted</v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <!-- GPT Mode Configuration -->
            <v-divider class="my-6"></v-divider>
            <div class="section-title">GPT Mode Configuration</div>

            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-switch v-model="setup.GPTMode" inset :label="`GPT Mode : ${setup.GPTMode == '0' ? 'Priority' : 'Fast'}`" small color="primary">
                  <template v-slot:label>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <label v-bind="attrs" v-on="on">{{ 'GPT Mode : ' + (setup.GPTMode == '0' ? 'Priority' : 'Fast') }}</label>
                      </template>
                      <span>GPT Mode</span>
                    </v-tooltip>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row v-show="setup.GPTMode == '1'">
              <v-col cols="12" sm="6" md="3">
                <v-text-field label="Repeat Time (Minutes)*" v-model="setup.GPTRepeatTime" @keypress="isNumber($event)" required density="comfortable" variant="outlined" :rules="[rules.required]">
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-clock</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  label="Model*"
                  :items="DDModelShow"
                  item-title="modelDisplay"
                  item-value="modelName"
                  density="comfortable"
                  variant="outlined"
                  clearable
                  v-model="setup.Model"
                  :rules="[rules.required]"
                  required
                >
                  <template v-slot:prepend-inner>
                    <v-icon small color="grey">mdi-robot-happy</v-icon>
                  </template>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text size="small" variant="text" density="comfortable" style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <span>{{ $t('_InfoModel') }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-show="setup.GPTMode == '1'">
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  id="Questions"
                  label="Test of Questions*"
                  density="comfortable"
                  variant="outlined"
                  counter
                  auto-grow
                  rows="6"
                  v-model="setup.Questions"
                  :maxlength="1000"
                  :rules="[rules.required]"
                  required
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-comment-question</v-icon>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-data-table v-show="setup.GPTMode == '1'" :items="listAzureEndpointFastMode" :headers="headers" hide-default-footer :items-per-page="listAzureEndpointFastMode.length">
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">{{ item.priority }}</td>
                  <td>{{ item.azureOpenAIUrl }}</td>
                  <td>{{ item.responseTime }}</td>
                  <td>{{ item.replytext }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <!-- AI Processing Endpoints Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-server-network</v-icon>
            <span>AI Processing Endpoints</span>
          </v-card-title>
          <v-card-text class="card-content">
            <v-row no-gutters class="mb-4">
              <v-col cols="12" md="8" class="px-1">
                <v-autocomplete
                  v-model="setup.legacyMaxTokensModels"
                  label="Legacy max_tokens Models"
                  :items="uniqueModelDataList"
                  item-title="modelName"
                  item-value="modelName"
                  multiple
                  chips
                  closable-chips
                  clearable
                  density="comfortable"
                  variant="outlined"
                  hint="เลือกชื่อ model/deployment ที่ยังใช้พารามิเตอร์ max_tokens (เช่น gpt-4o, gpt-35-turbo) — model ที่ไม่อยู่ในรายการนี้จะใช้ max_completion_tokens (สำหรับ GPT model ใหม่)"
                  persistent-hint
                  @update:model-value="NormalizeLegacyMaxTokensModels"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey">mdi-tag-multiple</v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" class="px-1">
                <v-text-field
                  label="Max Tokens (Entity Extraction)"
                  v-model="setup.entityExtractionMaxTokens"
                  density="comfortable"
                  variant="outlined"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey">mdi-counter</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-4">
              <v-col cols="12" md="6" class="px-1">
                <v-text-field
                  label="Max Tokens (Community / Meta-Community Graph)"
                  v-model="setup.communityGraphMaxTokens"
                  density="comfortable"
                  variant="outlined"
                  hint="จำนวน token สูงสุดของการสร้างสรุป Community / Meta-Community Graph (ค่าเริ่มต้น 350)"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey">mdi-counter</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="px-1">
                <v-text-field
                  label="Max Tokens (Document / Meta-Document Chunking)"
                  v-model="setup.autoChunkMaxTokens"
                  density="comfortable"
                  variant="outlined"
                  hint="จำนวน token สูงสุดของการแบ่ง chunk เอกสาร Document / Meta-Document ด้วย LLM (ค่าเริ่มต้น 1000)"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey">mdi-counter</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="px-1 mt-4">
                <v-text-field
                  label="Max Chunk Size (characters)"
                  v-model="setup.autoChunkMaxChunkSize"
                  density="comfortable"
                  variant="outlined"
                  hint="ขนาด chunk สูงสุด (ตัวอักษร) ของ Meta-Document และข่าวที่ดึงอัตโนมัติ (ค่าเริ่มต้น 5000, 500–20000) · เนื้อหาไทยไม่ควรเกิน ~7000 เพราะติดเพดาน token ของ embedding · ข่าวที่ import แล้วไม่ถูกตัดใหม่เอง"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey">mdi-format-text-variant</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-divider class="mb-6"></v-divider>

            <template v-for="section in aiProcessingSections" :key="section.key">
              <div class="section-title">{{ section.title }}</div>

              <div v-for="(item, index) in section.list" :key="`${section.key}-${index}`" class="endpoint-card">
                <v-row no-gutters>
                  <v-col cols="12" md="1" class="px-1">
                    <v-text-field label="Priority" v-model="item.priorityDisplay" :rules="[rules.required]" density="comfortable" variant="outlined" @keypress="isNumberpositive($event)">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey">mdi-sort-numeric-ascending</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" class="px-1">
                    <v-text-field label="Azure URL" v-model="item.azureUrl" :rules="[rules.required]" density="comfortable" variant="outlined">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey">mdi-link</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" class="px-1">
                    <v-text-field label="API Key" v-model="item.apiKey" :rules="[rules.required]" density="comfortable" variant="outlined" :type="item.showValue ? 'text' : 'password'">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey">mdi-key</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn icon size="small" variant="text" density="comfortable" @click="item.showValue = !item.showValue">
                          <v-icon size="small">{{ item.showValue ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="2" class="px-1">
                    <v-autocomplete
                      label="Deployment"
                      v-model="item.deployment"
                      :items="uniqueModelDataList"
                      item-title="modelName"
                      item-value="modelName"
                      :rules="[rules.required]"
                      density="comfortable"
                      variant="outlined"
                      clearable
                      @update:model-value="UpdateAIProcessingEndpointApiVersion(item)"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey">mdi-rocket-launch</v-icon>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2" class="px-1">
                    <v-text-field label="API Version" v-model="item.apiVersion" :rules="[rules.required]" density="comfortable" variant="outlined">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey">mdi-version</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="1" class="d-flex align-center justify-end">
                    <v-btn icon color="error" variant="text" density="comfortable" @click="DeleteAIProcessingEndpoint(section.key, index)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>

              <v-btn outlined color="primary" @click="AddAIProcessingEndpoint(section.key)" class="add-endpoint-btn">
                <v-icon location="left">mdi-plus</v-icon>
                Add {{ section.title }}
              </v-btn>

              <v-divider class="my-6"></v-divider>
            </template>
          </v-card-text>
        </v-card>

        <!-- Storage Configuration Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-database</v-icon>
            <span>Storage Configuration</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="storage-section">
              <div class="section-subtitle">Azure Blob Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageConnection"
                    :rules="[rules.required]"
                    :type="setup.Show_AzureStorageConnection ? 'text' : 'password'"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AzureStorageConnection = !setup.Show_AzureStorageConnection">
                        <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AzureStorageConnection ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Container Name" v-model="setup.azureContainer" :rules="[rules.required]" density="comfortable" variant="outlined">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">CIF Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageConnectionCif"
                    :type="setup.Show_AzureStorageConnectionCif ? 'text' : 'password'"
                    density="comfortable"
                    variant="outlined"
                    persistent-hint
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AzureStorageConnectionCif = !setup.Show_AzureStorageConnectionCif">
                        <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AzureStorageConnectionCif ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Container Name" v-model="setup.azureContainerCif" density="comfortable" variant="outlined" persistent-hint>
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">PDF Vector Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageConnectionPDFVector"
                    :rules="[rules.required]"
                    :type="setup.Show_AzureStorageConnectionPDFVector ? 'text' : 'password'"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AzureStorageConnectionPDFVector = !setup.Show_AzureStorageConnectionPDFVector">
                        <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AzureStorageConnectionPDFVector ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Container Name" v-model="setup.azureContainerPDFVector" :rules="[rules.required]" density="comfortable" variant="outlined">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">Image Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageConnectionImage"
                    :rules="[rules.required]"
                    :type="setup.Show_AzureStorageConnectionImage ? 'text' : 'password'"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AzureStorageConnectionImage = !setup.Show_AzureStorageConnectionImage">
                        <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AzureStorageConnectionImage ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Container Name" v-model="setup.azureContainerImage" :rules="[rules.required]" density="comfortable" variant="outlined">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">Speech Document Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureStorageSpeech"
                    :rules="[rules.required]"
                    :type="setup.Show_AzureStorageSpeech ? 'text' : 'password'"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AzureStorageSpeech = !setup.Show_AzureStorageSpeech">
                        <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AzureStorageSpeech ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Container Name" v-model="setup.azureContainerSpeech" :rules="[rules.required]" density="comfortable" variant="outlined">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">Quick Reply Icon Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureQuickReplyIconStorage"
                    :rules="[rules.required]"
                    :type="setup.Show_AzureQuickReplyIconStorage ? 'text' : 'password'"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AzureQuickReplyIconStorage = !setup.Show_AzureQuickReplyIconStorage">
                        <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AzureQuickReplyIconStorage ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Container Name" v-model="setup.azureQuickReplyIconContainer" :rules="[rules.required]" density="comfortable" variant="outlined">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <div class="storage-section">
              <div class="section-subtitle">Prefix Storage</div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Storage Connection"
                    v-model="setup.azureGeniePrefixStorage"
                    :type="setup.Show_AzureGeniePrefixStorage ? 'text' : 'password'"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-connection</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AzureGeniePrefixStorage = !setup.Show_AzureGeniePrefixStorage">
                        <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AzureGeniePrefixStorage ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="Container Name" v-model="setup.azureGeniePrefixContainer" density="comfortable" variant="outlined">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>

        <!-- Language Services Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-translate</v-icon>
            <span>Language Services</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="service-tabs">
              <v-tabs v-model="activeLanguageTab" color="primary" slider-color="primary">
                <v-tab>Translator</v-tab>
                <v-tab>Language Service</v-tab>
                <v-tab>Speech to Text</v-tab>
                <v-tab>Text to Speech</v-tab>
                <v-tab>Gemini Text to Speech</v-tab>
              </v-tabs>

              <!-- แก้ไขจาก v-tabs-items เป็น v-window -->
              <v-window v-model="activeLanguageTab">
                <v-window-item>
                  <v-row class="mt-4">
                    <v-col cols="12" md="4">
                      <v-text-field label="Endpoint" v-model="setup.languageTranslatorEndpoint" :rules="[rules.required]" density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-link</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="API Key"
                        v-model="setup.languageTranslatorKey"
                        :rules="[rules.required]"
                        :type="setup.Show_LanguageTranslatorKey ? 'text' : 'password'"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                        </template>
                        <template v-slot:append-inner>
                          <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_LanguageTranslatorKey = !setup.Show_LanguageTranslatorKey">
                            <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_LanguageTranslatorKey ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field label="Location" v-model="setup.languageTranslatorLocation" :rules="[rules.required]" density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-map-marker</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-window-item>
                <v-window-item>
                  <v-row class="mt-4">
                    <v-col cols="12" md="6">
                      <v-text-field label="Language Endpoint" v-model="setup.languageEndpoint" :rules="[rules.required]" density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-link</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Language Key"
                        v-model="setup.languageKey"
                        :rules="[rules.required]"
                        :type="setup.Show_LanguageKey ? 'text' : 'password'"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                        </template>
                        <template v-slot:append-inner>
                          <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_LanguageKey = !setup.Show_LanguageKey">
                            <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_LanguageKey ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-window-item>
                <v-window-item>
                  <v-row class="mt-4">
                    <v-col cols="12" md="4">
                      <v-text-field label="Speech to Text Endpoint" v-model="setup.speechToTextEndpoint" :rules="[rules.required]" density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-link</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        label="Speech to Text Key"
                        v-model="setup.speechToTextKey"
                        :rules="[rules.required]"
                        :type="setup.Show_SpeechToTextKey ? 'text' : 'password'"
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                        </template>
                        <template v-slot:append-inner>
                          <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_SpeechToTextKey = !setup.Show_SpeechToTextKey">
                            <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_SpeechToTextKey ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field label="Speech to Text Region" v-model="setup.speechToTextRegion" :rules="[rules.required]" density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-map-marker-outline</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-switch v-model="setup.speechToTextUseEndpointIOS" inset color="primary" hide-details label="Use Endpoint for iOS" />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-switch v-model="setup.speechToTextUseEndpointAndroid" inset color="primary" hide-details label="Use Endpoint for Android" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field label="Speech to Text Language" v-model="setup.speechToTextLanguage" :rules="[rules.required]" density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-translate</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <!-- add field Path FFmpeg -->
                      <v-text-field label="FFmpeg Path" v-model="setup.pathFFMpeg" :rules="[rules.required]" density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <!-- add field Path FFmpeg local -->
                      <v-text-field label="FFmpeg Local Path" v-model="setup.pathFFMpegLocal" :rules="[rules.required]" density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-folder</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <!-- Google STT V2 — the app gets an access token from Other Config → Google Config (JSON), never the JSON -->
                  <div class="d-flex align-center mt-2 mb-3">
                    <v-icon color="primary" class="mr-2">mdi-google</v-icon>
                    <span class="text-subtitle-1 font-weight-medium">Google STT V2</span>
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Google STT V2 Endpoint"
                        v-model="setup.googleSttEndpoint"
                        :placeholder="googleSttDefaultEndpoint"
                        persistent-placeholder
                        hint="Leave empty to use the default built from project_id in the JSON credential + Location"
                        persistent-hint
                        density="comfortable"
                        variant="outlined"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-link</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field label="Location" v-model="setup.googleSttLocation" placeholder="us" persistent-placeholder hint="Chirp 3: us / eu" persistent-hint density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-map-marker-outline</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field label="Model" v-model="setup.googleSttModel" placeholder="chirp_3" persistent-placeholder density="comfortable" variant="outlined">
                        <template v-slot:prepend-inner>
                          <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-cube-outline</v-icon>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-alert type="info" variant="tonal" density="compact">
                        Credential = Other Config → Google Config (JSON; the project comes from its project_id). Mobile calls POST
                        /api/v1/LHB/GetGoogleSTTV2TokenLHB to get data = one AES-GCM "v2:" string (Token + ProjectId + Endpoint + Model), decrypts it, sends Token to Google as "Authorization: Bearer"
                        with its own languageCodes, and asks again when Google answers 401.
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-window-item>
                <v-window-item>
                  <div class="mt-4">
                    <div v-for="(item, index) in setupListTextToSpeech" :key="index" class="endpoint-card">
                      <v-row no-gutters>
                        <v-col cols="12" md="4" class="px-2">
                          <v-text-field label="Text to Speech Endpoint" v-model="item.endpoint" :rules="[rules.required]" density="comfortable" variant="outlined">
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-link</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" class="px-2">
                          <v-text-field label="API Key" v-model="item.apiKey" :rules="[rules.required]" density="comfortable" variant="outlined" :type="item.showValue ? 'text' : 'password'">
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-key</v-icon>
                            </template>
                            <template v-slot:append-inner>
                              <v-btn icon size="small" variant="text" density="comfortable" @click="item.showValue = !item.showValue">
                                <v-icon size="small">{{ item.showValue ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="px-2">
                          <v-text-field label="Region" v-model="item.region" :rules="[rules.required]" density="comfortable" variant="outlined">
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-map-marker-outline</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="1" class="d-flex align-center justify-end">
                          <v-btn icon color="error" variant="text" density="comfortable" @click="DeleteTextToSpeech(index)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>

                    <v-btn outlined color="primary" @click="AddTextToSpeech()" class="add-endpoint-btn">
                      <v-icon location="left">mdi-plus</v-icon>
                      Add Text to Speech
                    </v-btn>
                  </div>
                </v-window-item>
                <!-- Gemini Text to Speech (Cloud TTS API) -->
                <v-window-item>
                  <div class="mt-4">
                    <div
                      v-for="(item, index) in geminiTtsList"
                      :key="index"
                      class="endpoint-card"
                    >
                      <v-row no-gutters>
                        <v-col cols="12" md="6" class="px-2">
                          <v-text-field
                            label="Endpoint"
                            v-model="item.endpoint"
                            density="comfortable"
                            variant="outlined"
                            :readonly="item.endpointLocked"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-link</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" class="px-2">
                          <v-text-field
                            label="API Key"
                            v-model="item.accessToken"
                            density="comfortable"
                            variant="outlined"
                            :type="item.showToken ? 'text' : 'password'"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-key</v-icon>
                            </template>
                            <template v-slot:append-inner>
                              <v-btn icon size="small" variant="text" density="comfortable"
                                @click="item.showToken = !item.showToken">
                                <v-icon size="small">{{ item.showToken ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="2" class="px-2">
                          <v-select
                            label="Model"
                            v-model="item.model"
                            :items="geminiTtsModelOptions"
                            item-title="text"
                            item-value="value"
                            density="comfortable"
                            variant="outlined"
                            @update:modelValue="onGeminiModelChange(item)"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-cube-outline</v-icon>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="1" class="d-flex align-center justify-end">
                          <v-btn
                            icon
                            color="error"
                            variant="text"
                            density="comfortable"
                            @click="DeleteGeminiTts(index)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="mt-2">
                        <v-col cols="12" md="4" class="px-2">
                          <v-select
                            label="Voice EN"
                            v-model="item.voiceNameEn"
                            :items="geminiVoiceOptions"
                            density="comfortable"
                            variant="outlined"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-account-voice</v-icon>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="4" class="px-2">
                          <v-select
                            label="Voice TH"
                            v-model="item.voiceNameTh"
                            :items="geminiVoiceOptions"
                            density="comfortable"
                            variant="outlined"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-account-voice</v-icon>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="4" class="px-2">
                          <v-select
                            label="Voice CN"
                            v-model="item.voiceNameCn"
                            :items="geminiVoiceOptions"
                            density="comfortable"
                            variant="outlined"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-account-voice</v-icon>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="mt-2">
                        <v-col cols="12" class="px-2">
                          <v-textarea
                            label="Style Instructions (prompt)"
                            v-model="item.instruction"
                            density="comfortable"
                            variant="outlined"
                            rows="2"
                            auto-grow
                            placeholder="e.g. Say the following in a curious way."
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-tune-variant</v-icon>
                            </template>
                          </v-textarea>
                        </v-col>
                      </v-row>
                    </div>

                    <v-btn
                      outlined
                      color="primary"
                      @click="AddGeminiTts()"
                      class="add-endpoint-btn"
                    >
                      <v-icon location="left">mdi-plus</v-icon>
                      Add Gemini Text to Speech
                    </v-btn>
                  </div>
                </v-window-item>
              </v-window>
            </div>
          </v-card-text>
        </v-card>
        <!-- Mail Config -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-mail</v-icon>
            <span>Mail Config</span>
          </v-card-title>
          <v-card-text class="card-content">
            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <v-select
                  label="Send mode"
                  v-model="setup.emailSendMode"
                  :items="emailSendModes"
                  item-title="title"
                  item-value="value"
                  density="comfortable"
                  variant="outlined"
                  hint="Used by every SMTP sender, including the Email node set to SMTP."
                  persistent-hint>
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-send-outline</v-icon>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field label="Email Host" v-model="setup.emailHost" :rules="[rules.required]" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-email</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <!-- add field Host name -->
                <v-text-field label="Host Name" v-model="setup.hostName" :rules="[rules.required]" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-domain</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col v-if="setup.emailSendMode === 'smtp'" cols="12" md="6">
                <!-- add field Password -->
                <v-text-field label="Password" v-model="setup.password" :rules="[rules.required]" :type="setup.Show_Password ? 'text' : 'password'" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-lock</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_Password = !setup.Show_Password">
                      <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_Password ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col v-else-if="setup.emailSendMode === 'acs_connection_string'" cols="12" md="6">
                <v-text-field
                  label="ACS connection string"
                  v-model.trim="setup.acsEmailConnectionString"
                  :rules="[rules.required]"
                  :type="setup.Show_AcsEmailConnectionString ? 'text' : 'password'"
                  placeholder="endpoint=https://<resource>.communication.azure.com/;accesskey=..."
                  density="comfortable"
                  variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AcsEmailConnectionString = !setup.Show_AcsEmailConnectionString">
                      <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AcsEmailConnectionString ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col v-else-if="setup.emailSendMode === 'acs_managed_identity'" cols="12" md="6">
                <v-text-field
                  label="ACS endpoint"
                  v-model.trim="setup.acsEmailEndpoint"
                  :rules="[rules.required]"
                  placeholder="https://<resource>.communication.azure.com"
                  density="comfortable"
                  variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-link-variant</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col v-if="setup.emailSendMode === 'smtp'" cols="12" md="4">
                <v-select
                  label="SMTP server"
                  v-model="smtpProvider"
                  :items="smtpPresets"
                  item-title="title"
                  item-value="value"
                  density="comfortable"
                  variant="outlined"
                  hint="Where Email Host signs in to send. Must match the mailbox above."
                  persistent-hint>
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-server-network</v-icon>
                  </template>
                </v-select>
              </v-col>

              <v-col v-if="setup.emailSendMode === 'smtp'" cols="12" md="5">
                <v-text-field
                  label="SMTP host"
                  v-model.trim="setup.smtpHost"
                  :readonly="smtpProvider !== 'custom'"
                  :rules="smtpProvider === 'custom' ? [rules.required] : []"
                  :placeholder="smtpProvider === 'custom' ? 'mail.example.com' : ''"
                  density="comfortable"
                  variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-dns</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col v-if="setup.emailSendMode === 'smtp'" cols="12" md="3">
                <v-text-field
                  label="SMTP port"
                  v-model.number="setup.smtpPort"
                  :readonly="smtpProvider !== 'custom'"
                  type="number"
                  min="1"
                  max="65535"
                  density="comfortable"
                  variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-lan-connect</v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col v-if="setup.emailSendMode === 'smtp' && smtpProvider === 'smtp.azurecomm.net'" cols="12">
                <div class="text-caption text-medium-emphasis">
                  Azure Communication Services: Email Host must be a MailFrom address of a domain connected to the Communication Services resource, and must also be added as an SMTP Username there. Password is the client secret of the Microsoft Entra app linked to that SMTP Username.
                </div>
              </v-col>

              <v-col v-if="setup.emailSendMode === 'acs_connection_string'" cols="12">
                <div class="text-caption text-medium-emphasis">
                  Copy the connection string from the Communication Services resource under Settings → Keys. Email Host must be a MailFrom address of a domain connected to that resource; the sender name shown to recipients comes from that MailFrom address, not Host Name.
                </div>
              </v-col>

              <v-col v-if="setup.emailSendMode === 'acs_managed_identity'" cols="12">
                <div class="text-caption text-medium-emphasis">
                  Turn on the system-assigned identity of the App Service that runs this API, then give it the Communication and Email Service Owner role on the Communication Services resource. Email Host must be a MailFrom address of a domain connected to that resource; the sender name shown to recipients comes from that MailFrom address, not Host Name.
                </div>
              </v-col>

              <v-col v-if="setup.emailSendMode === 'smtp'" cols="12">
                <div class="text-caption text-medium-emphasis">
                  Personal Outlook.com mailboxes no longer accept a password over SMTP (Microsoft removed basic authentication in September 2024) — use a Microsoft 365 work mailbox, Gmail with an app password, or your own relay.
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- System Settings Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-cog</v-icon>
            <span>System Settings</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="settings-grid">
              <div class="setting-item">
                <v-switch v-model="setup.autoStream" color="blue" class="modern-switch" inset>
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text" density="comfortable" class="mr-2">mdi-lightning-bolt</v-icon>
                      <span>Auto Stream: {{ setup.autoStream ? 'Enabled' : 'Disabled' }}</span>
                    </div>
                  </template>
                </v-switch>
              </div>

              <div class="setting-item">
                <v-switch v-model="setup.anonymous" color="blue" class="modern-switch" inset>
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text" density="comfortable" class="mr-2">mdi-incognito</v-icon>
                      <span>Anonymous Mode: {{ setup.anonymous ? 'On' : 'Off' }}</span>
                    </div>
                  </template>
                </v-switch>
              </div>
            </div>

            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <v-text-field label="Time Delay (ms)" v-model="setup.TimeDelayCharacter" @keypress="isNumber($event)" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-timer</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="Character Limit" v-model="setup.LimitedCharacter" @keypress="isNumber($event)" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-format-letter-case</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <div class="settings-grid">
              <div class="setting-item">
                <v-switch v-model="setup.FlagDisableGPT" color="blue" class="modern-switch" inset>
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text" density="comfortable" class="mr-2">mdi-gift</v-icon>
                      <span>Force Disable GPT</span>
                    </div>
                  </template>
                </v-switch>
              </div>
              <div cols="12" md="6" class="setting-item">
                <v-switch v-model="setup.FlagAutoDisableGPT" color="blue" class="modern-switch" inset>
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text" density="comfortable" class="mr-2">mdi-repeat</v-icon>
                      <span>Auto Disable GPT: {{ setup.FlagAutoDisableGPT ? 'on' : 'off' }}</span>
                    </div>
                  </template>
                </v-switch>
              </div>
            </div>

            <v-row class="mt-4">
              <v-col cols="12" md="6">
                <!-- add field GPT Auto-Disable Period -->
                <v-text-field label="GPT Auto-Disable Date Period" v-model="setup.AutoDisableGPTPeriodDate" @keypress="isNumber($event)" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-timer-sand</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <!-- add field GPT Auto-Disable Message -->
                <v-text-field label="GPT Auto-Disable Message" v-model="setup.AutoDisableGPTMessage" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-comment-question</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="GPT Auto-Disable Pricing (USD)" v-model="setup.AutoDisableGPTPricing" @keypress="isNumber($event)" density="comfortable" variant="outlined">
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-currency-usd</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Call Center — MIAW / Webhook Traffic Log
             ค่าทั้ง 5 ตัวอ่านจาก sy.Dbsettings ตอน runtime (BAL/BAL/AppBAL/Social/SocialApiLogSwitch.cs)
             กด Save แล้วมีผลทันที เพราะ UpdateGeneral เรียก RefreshConfigurationAsync() ต่อท้าย
             ⚠️ ทั้งสองสวิตช์เริ่มที่ปิด — เปิดแล้วระบบเริ่มเก็บบทสนทนาของลูกค้าธนาคารจริง -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-message-text-lock</v-icon>
            <span>{{ $t('_ccLogCardTitle') }}</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="section-title">{{ $t('_ccLogCardSubtitle') }}</div>

            <div class="settings-grid">
              <div class="setting-item">
                <v-switch v-model="setup.socialApiLogEnabled" color="blue" class="modern-switch" inset hide-details>
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text" density="comfortable" class="mr-2">mdi-record-circle-outline</v-icon>
                      <span>{{ $t('_ccLogEnabled') }}: {{ setup.socialApiLogEnabled ? $t('_socialApiLogOn') : $t('_socialApiLogOff') }}</span>
                    </div>
                  </template>
                </v-switch>
                <div class="setting-hint">{{ $t('_ccLogEnabledHint') }}</div>
              </div>

              <div class="setting-item">
                <v-switch v-model="setup.socialApiLogBodyEnabled" color="blue" class="modern-switch" inset hide-details>
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text" density="comfortable" class="mr-2">mdi-text-box-outline</v-icon>
                      <span>{{ $t('_ccLogBodyEnabled') }}: {{ setup.socialApiLogBodyEnabled ? $t('_socialApiLogOn') : $t('_socialApiLogOff') }}</span>
                    </div>
                  </template>
                </v-switch>
                <div class="setting-hint">{{ $t('_ccLogBodyEnabledHint') }}</div>
              </div>
            </div>

            <!-- เปิด body ไว้แต่ปิดการบันทึก = ไม่มีอะไรเกิดขึ้นเลย ต้องบอกให้รู้
                 ไม่งั้นคนตั้งค่าจะรอดู log ที่ไม่มีวันมา -->
            <v-alert
              v-if="setup.socialApiLogBodyEnabled && !setup.socialApiLogEnabled"
              type="info" variant="tonal" density="compact" class="mt-3" icon="mdi-information-outline"
            >
              <span class="text-body-2">{{ $t('_ccLogBodyNeedsRecording') }}</span>
            </v-alert>
            <v-alert
              v-else-if="setup.socialApiLogBodyEnabled"
              type="warning" variant="tonal" density="compact" class="mt-3" icon="mdi-shield-alert-outline"
            >
              <span class="text-body-2">{{ $t('_ccLogBodyWarning') }}</span>
            </v-alert>

            <v-row class="mt-4">
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$t('_ccLogRetentionDays')"
                  v-model="setup.socialApiLogRetentionDays"
                  density="comfortable"
                  variant="outlined"
                  type="number"
                  :hint="$t('_ccLogRetentionDaysHint')"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-calendar-clock</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$t('_ccLogMaxBodyKB')"
                  v-model="setup.socialApiLogMaxBodyKB"
                  density="comfortable"
                  variant="outlined"
                  type="number"
                  :hint="$t('_ccLogMaxBodyKBHint')"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-scale-balance</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$t('_ccLogRowRetentionDays')"
                  v-model="setup.socialApiLogRowRetentionDays"
                  density="comfortable"
                  variant="outlined"
                  type="number"
                  :hint="$t('_ccLogRowRetentionDaysHint')"
                  persistent-hint
                  @keypress="isNumberpositive($event)"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-database-clock-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- App Knowledge Center — การ์ดนี้บันทึก/ทดสอบเอง ไม่ผูกกับ Save รวม · role 2 ได้ 401 แล้วการ์ดซ่อนตัวเอง -->
        <KccSettingsCard v-if="kccCardVisible" :view-only="isViewOnly" @forbidden="kccCardVisible = false" />

        <!-- other config -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-cog</v-icon>
            <span>Other Config</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="service-tabs">
              <v-tabs v-model="otherTab" color="primary" slider-color="primary">
                <v-tab>Google Config</v-tab>
                <v-tab>ANTHROPIC CONFIG</v-tab>
                <v-tab>OPENAI CONFIG</v-tab>
                <v-tab>Fail Config</v-tab>
              </v-tabs>
            </div>

            <v-window v-model="otherTab">
              <v-window-item>
                <v-row class="mt-4">
                  <v-col cols="12" md="6">
                    <!-- add field ProjectID -->
                    <v-text-field label="Project ID" v-model="setup.projectID" :rules="[rules.required]" density="comfortable" variant="outlined">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-projector</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <!-- Fallback LocationID (used when no multi-region configured) -->
                    <v-text-field
                      label="Default Location ID (fallback)"
                      v-model="setup.locationID"
                      density="comfortable"
                      variant="outlined"
                      hint="Used when no Gemini Locations are configured below"
                      persistent-hint
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-map-marker</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Gemini Timeout (seconds)"
                      v-model="setup.geminiTimeout"
                      density="comfortable"
                      variant="outlined"
                      type="number"
                      hint="Cut request if too slow (0 = no limit)"
                      persistent-hint
                      @keypress="isNumberpositive($event)"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-timer-outline</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Max Retry"
                      v-model="setup.geminiMaxRetry"
                      density="comfortable"
                      variant="outlined"
                      type="number"
                      hint="Retry count on failure (0 = no retry)"
                      persistent-hint
                      @keypress="isNumberpositive($event)"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-refresh</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>

                  <!-- Gemini Locations (Multi-Region Load Balancing) -->
                  <v-col cols="12" md="12">
                    <div class="section-subtitle" style="font-weight: 600; margin-bottom: 8px">Gemini Locations (Multi-Region)</div>

                    <div v-for="(item, index) in setupListGeminiLocation" :key="'gemini-' + index" class="endpoint-card">
                      <v-row no-gutters>
                        <v-col cols="12" md="3">
                          <v-text-field
                            label="Priority"
                            v-model="item.priorityDisplay"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                            @keypress="isNumberpositive($event)"
                            class="priority-field"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-sort-numeric-ascending</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="7" class="px-2">
                          <v-text-field
                            label="Location ID"
                            v-model="item.locationId"
                            placeholder="e.g. global, us-central1, asia-southeast1"
                            :rules="[rules.required]"
                            density="comfortable"
                            variant="outlined"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="grey">mdi-map-marker</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="2" class="d-flex align-center justify-end">
                          <v-btn v-if="index !== 0" icon color="error" variant="text" density="comfortable" @click="DeleteGeminiLocation(index)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>

                    <v-btn outlined color="primary" @click="AddGeminiLocation()" class="add-endpoint-btn" v-show="setupListGeminiLocation.length > 0">
                      <v-icon location="left">mdi-plus</v-icon>
                      Add Location
                    </v-btn>
                    <v-btn v-show="setupListGeminiLocation.length === 0" outlined color="primary" @click="AddGeminiLocation()" class="add-endpoint-btn">
                      <v-icon location="left">mdi-plus</v-icon>
                      Add Gemini Location
                    </v-btn>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" style="display: flex; justify-content: end; gap: 4px" class="d-flex justify-between align-center mb-3 mr-3">
                    <span class="mt-3">JSON Credential</span>
                    <!--<v-icon :disabled="!isUploadFileJSON" color="green" large> mdi-check-circle </v-icon>
                      <span>{{ tempFileJSON != null && tempFileJSON != '' && tempFileJSON != undefined ? tempFileJSON.name : '' }}</span> -->
                    <DragDropFile :dialog="true" :DragDrop="false" :ShowListFile="false" :allowType="['application/json']" :accept="'application/json'" @filesUploaded="uploadFile($event)" />
                    <v-icon class="mt-3" :disabled="!isUploadFileJSON" color="green" large style="padding-top: 10px"> mdi-check-circle </v-icon>
                    <span>{{ tempFileJSON != null && tempFileJSON != '' && tempFileJSON != undefined ? tempFileJSON.name : '' }}</span>
                  </v-col>
                </v-row>
              </v-window-item>

              <v-window-item>
                <v-row class="mt-4">
                  <v-col cols="12" md="12">
                    <v-text-field
                      label="Anthropic APIKey"
                      v-model="setup.amazonClaude_APIKey"
                      :rules="[rules.required]"
                      :type="setup.Show_AmazonClaude_APIKey ? 'text' : 'password'"
                      density="comfortable"
                      variant="outlined"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_AmazonClaude_APIKey = !setup.Show_AmazonClaude_APIKey">
                          <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_AmazonClaude_APIKey ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-window-item>

              <v-window-item>
                <v-row class="mt-4">
                  <v-col cols="12" md="12">
                    <v-text-field
                      label="OpenAI API Key"
                      v-model="setup.openAIAPIKey"
                      :rules="[rules.required]"
                      :type="setup.Show_OpenAI_APIKey ? 'text' : 'password'"
                      density="comfortable"
                      variant="outlined"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_OpenAI_APIKey = !setup.Show_OpenAI_APIKey">
                          <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_OpenAI_APIKey ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-window-item>

              <v-window-item>
                <v-row class="mt-4">
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Endpoint Suspense Minutes"
                      v-model="setup.endpointSuspenseMinutes"
                      density="comfortable"
                      variant="outlined"
                      type="number"
                      hint="Minutes before suspended Azure/Gemini endpoints can be retried"
                      persistent-hint
                      @keypress="isNumberpositive($event)"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-timer-sand</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="1" class="px-2"></v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>

        <!-- single sign on -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-cog</v-icon>
            <span>Single Sing-On</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="service-tabs">
              <v-tabs v-model="signOnTab" color="primary" slider-color="primary">
                <v-tab v-for="(item, index) in setupOpenIDConnectList" :key="index">{{ item.provider }}</v-tab>
              </v-tabs>
            </div>

            <v-window v-model="signOnTab" class="mt-4">
              <v-window-item v-for="(item, index) in setupOpenIDConnectList" :key="index">
                <div class="settings-grid">
                  <div class="setting-item">
                    <v-switch v-model="item.sso" color="blue" class="modern-switch" inset>
                      <template v-slot:label>
                        <div class="switch-label">
                          <v-icon size="small" variant="text" density="comfortable" class="mr-2">mdi-account-switch</v-icon>
                          <span>{{ 'Single Sign-On ' + item.provider + ': ' + (item.sso ? 'Open' : 'Close') }}</span>
                        </div>
                      </template>
                    </v-switch>
                  </div>
                  <div class="setting-item">
                    <v-switch v-model="item.ssoChat" color="blue" class="modern-switch" inset>
                      <template v-slot:label>
                        <div class="switch-label">
                          <span>{{ 'Single Sign-On ' + item.provider + ' in Chat: ' + (item.ssoChat ? 'Open' : 'Close') }}</span>
                        </div>
                      </template>
                    </v-switch>
                  </div>
                </div>
                <v-row>
                  <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Line'">
                    <v-text-field label="Instance" v-model="item.instance" :rules="[rules.required]" density="comfortable" variant="outlined" :disabled="item.provider == 'Microsoft'">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Authentik' && item.provider != 'Line'">
                    <v-text-field label="Domain" v-model="item.domain" :rules="[rules.required]" density="comfortable" variant="outlined">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-domain</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Authentik' && item.provider != 'Line'">
                    <v-text-field label="Tenant ID" v-model="item.tenantId" :rules="[rules.required]" density="comfortable" variant="outlined" :type="item.Show_TenantId ? 'text' : 'password'">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-domain</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn icon size="small" variant="text" density="comfortable" @click="item.Show_TenantId = !item.Show_TenantId">
                          <v-icon size="small" variant="text" density="comfortable">{{ item.Show_TenantId ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="Client ID" v-model="item.clientId" :rules="[rules.required]" density="comfortable" variant="outlined" :type="item.Show_ClientId ? 'text' : 'password'">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn icon size="small" variant="text" density="comfortable" @click="item.Show_ClientId = !item.Show_ClientId">
                          <v-icon size="small" variant="text" density="comfortable">{{ item.Show_ClientId ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Authentik'">
                    <v-text-field label="Callback Path" v-model="item.callbackPath" :rules="[rules.required]" density="comfortable" variant="outlined">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-link</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      label="Client Secret"
                      v-model="item.clientSecret"
                      :rules="[rules.required]"
                      density="comfortable"
                      variant="outlined"
                      :type="item.Show_ClientSecret ? 'text' : 'password'"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-lock</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn icon size="small" variant="text" density="comfortable" @click="item.Show_ClientSecret = !item.Show_ClientSecret">
                          <v-icon size="small" variant="text" density="comfortable">{{ item.Show_ClientSecret ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-show="item.provider != 'Authentik' && item.provider != 'Line'">
                    <v-text-field label="API Scope" v-model="item.apiScope" :rules="[rules.required]" density="comfortable" variant="outlined" :type="item.Show_APIScope ? 'text' : 'password'">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-scope</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn icon size="small" variant="text" density="comfortable" @click="item.Show_APIScope = !item.Show_APIScope">
                          <v-icon size="small" variant="text" density="comfortable">{{ item.Show_APIScope ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <!-- add field URLConfig -->
                    <v-text-field label="URL Config" v-model="item.urlConfig" :rules="[rules.required]" density="comfortable" variant="outlined">
                      <template v-slot:prepend-inner>
                        <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-web</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-card-text>
        </v-card>

        <!-- Summary Agent Configuration Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-robot-outline</v-icon>
            <span>Summary Agent Configuration</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="section-title">Active Summary Agents</div>

            <div v-for="(item, index) in summaryAgentList" :key="item.id || index" class="endpoint-card">
              <v-row no-gutters>
                <v-col cols="12" md="5">
                  <v-text-field label="Agent Key" v-model="item.key" :rules="[rules.required]" density="comfortable" variant="outlined" placeholder="Enter agent key name">
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey">mdi-key-variant</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="5" class="px-2">
                  <v-select
                    label="Model ID"
                    v-model="item.value"
                    :items="gptModelList"
                    item-title="displayText"
                    item-value="modelId"
                    :rules="[rules.required]"
                    density="comfortable"
                    variant="outlined"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="small" color="grey">mdi-robot</v-icon>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="2" class="d-flex align-center justify-end">
                  <v-btn v-if="summaryAgentList.length > 1" icon color="error" variant="text" density="comfortable" @click="DeleteSummaryAgent(index, item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <v-btn outlined color="primary" @click="AddSummaryAgent()" class="add-endpoint-btn">
              <v-icon location="left">mdi-plus</v-icon>
              Add Summary Agent
            </v-btn>
          </v-card-text>
        </v-card>

        <!-- Microsoft Entra ID Group Configuration Card -->
        <v-card class="config-card" elevation="2">
          <v-card-title class="card-header">
            <v-icon color="white" class="mr-3">mdi-account-group</v-icon>
            <span>Microsoft Entra ID Group Configuration</span>
          </v-card-title>
          <v-card-text class="card-content">
            <div class="settings-grid">
              <div class="setting-item">
                <v-switch v-model="syncSSO" color="blue" class="modern-switch" inset>
                  <template v-slot:label>
                    <div class="switch-label">
                      <v-icon size="small" variant="text" density="comfortable" class="mr-2">mdi-sync</v-icon>
                      <span>Sync SSO Groups</span>
                    </div>
                  </template>
                </v-switch>
              </div>
            </div>

            <v-row class="mt-4">
              <v-col cols="12" md="12">
                <v-text-field
                  label="Tenant ID"
                  v-model="setup.SecurityGroupTenantID"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                  :type="setup.Show_SecurityGroupTenantID ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-domain</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_SecurityGroupTenantID = !setup.Show_SecurityGroupTenantID">
                      <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_SecurityGroupTenantID ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-text-field
                  label="Client ID"
                  v-model="setup.SecurityGroupClientID"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                  :type="setup.Show_SecurityGroupClientID ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-key</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_SecurityGroupClientID = !setup.Show_SecurityGroupClientID">
                      <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_SecurityGroupClientID ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-text-field
                  label="ClientSecret"
                  v-model="setup.SecurityGroupClientSecrete"
                  :rules="[rules.required]"
                  density="comfortable"
                  variant="outlined"
                  :type="setup.Show_SecurityGroupClientSecrete ? 'text' : 'password'"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="small" color="grey" variant="text" density="comfortable">mdi-lock</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-btn icon size="small" variant="text" density="comfortable" @click="setup.Show_SecurityGroupClientSecrete = !setup.Show_SecurityGroupClientSecrete">
                      <v-icon size="small" variant="text" density="comfortable">{{ setup.Show_SecurityGroupClientSecrete ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- ...existing other configuration cards with similar modern styling... -->
      </div>
    </v-container>

    <!-- Loading Dialog -->
    <v-dialog v-model="dialog" persistent width="320">
      <v-card class="loading-card">
        <v-card-text class="text-center py-6">
          <v-progress-circular indeterminate color="primary" size="48" class="mb-4"></v-progress-circular>
          <div class="loading-text">Saving configuration...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import checkPermissionFour from "@/api/function.js";
import LogTrace from '@/api/function.js';
import { mask } from 'vue-the-mask';
import DragDropFile from '@/components/DragDropFile.vue';
import KccSettingsCard from '@/components/KnowledgeCenterClient/KccSettingsCard.vue';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
export default {
  name: 'Setup',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  components: { DragDropFile, KccSettingsCard },
  mixins: [LogTrace],
  directives: {
    mask,
  },
  data: () => ({
    mask: '##########',
    kccCardVisible: true,
    showStickySaveButton: false,
    scrollThreshold: 145,
    items: [],
    panel: [0],
    activeLanguageTab: 0,
    otherTab: 0,
    signOnTab: 0,

    show1: false,
    formHasErrors: false,
    permission: {
      add: true,
      edit: true,
      delete: true,
    },
    mailcheck: false,
    phonecheck: false,
    filters: {
      username: [],
      email: [],
      employeeName: [],
      userType: [],
    },
    DDRole: [
      {
        name: 'Admin',
        value: 1,
      },
      {
        name: 'ผู้ใช้งานทั่วไป',
        value: 2,
      },
    ],
    numberRules: [(v) => !!v || 'Input is required!'],
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 10 || 'Min 10 numbers',
    },
    Email: null,
    gg: null,
    UserType: null,
    dialog: false,
    edit: {
      id: null,
      key: null,
      value: null,
    },
    user: {
      id: null,
      key: null,
      value: null,
    },

    Editdialog: false,
    Adddialog: false,
    isSearch: false,
    searchname: '',
    email: '',
    totalTable: 0,
    itemsPerPage: 10,
    searchTotalTable: 0,
    options: {},
    today: null,
    setupList: [],
    // value is the SMTP host itself, so the saved setting stays the single source of truth
    smtpPresets: [
      { title: 'Microsoft 365 / Office 365', value: 'smtp.office365.com', port: 587 },
      { title: 'Gmail', value: 'smtp.gmail.com', port: 587 },
      { title: 'Outlook.com (personal)', value: 'smtp-mail.outlook.com', port: 587 },
      { title: 'Azure Communication Services', value: 'smtp.azurecomm.net', port: 587 },
      { title: 'Custom / self-hosted', value: 'custom', port: 587 },
    ],
    smtpCustom: false,
    // value is what EmailSendMode stores; SentMailBAL treats an empty or unknown value as smtp
    emailSendModes: [
      { title: 'SMTP', value: 'smtp' },
      { title: 'Azure Communication Services · connection string', value: 'acs_connection_string' },
      { title: 'Azure Communication Services · managed identity', value: 'acs_managed_identity' },
    ],
    setupListAzureOpenAIEndpoint: [],
    setupListGeminiLocation: [],
    setupListTextToSpeech: [],
    geminiTtsList: [
      {
        endpoint: "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-tts:generateContent",
        endpointLocked: true,
        location: "global",
        accessToken: "temp_token",
        showToken: false,
        model: "gemini-2.5-flash-preview-tts",
        voiceNameEn: "Leda",
        voiceNameTh: "Leda",
        voiceNameCn: "Leda",
        instruction: "A warm, conversational young voice — like a knowledgeable kid explaining something to a friend. Upbeat and approachable, with gentle emphasis on key words to guide the listener. The tone feels honest and direct, never overly polished, but always easy to trust.",
      },
    ],
    geminiTtsModelOptions: [
      { text: "Gemini 2.5 Flash Preview TTS", value: "gemini-2.5-flash-preview-tts" },
      { text: "Gemini 2.5 Pro Preview TTS", value: "gemini-2.5-pro-preview-tts" },
      { text: "Gemini 3.1 Flash TTS Preview", value: "gemini-3.1-flash-tts-preview" },
    ],
    geminiLanguageOptions: [
      { text: "English (United States)", value: "en-US" },
      { text: "Thai (Thailand)", value: "th-TH" },
      { text: "Chinese, Mandarin (China)", value: "cmn-CN" },
    ],
    geminiVoiceOptions: [
      "Achernar", "Achird", "Algenib", "Algieba", "Alnilam", "Aoede", "Autonoe",
      "Callirrhoe", "Charon", "Despina", "Enceladus", "Erinome", "Fenrir", "Gacrux",
      "Iapetus", "Kore", "Laomedeia", "Leda", "Orus", "Pulcherrima", "Puck",
      "Rasalgethi", "Sadachbia", "Sadaltager", "Schedar", "Sulafat", "Umbriel",
      "Vindemiatrix", "Zephyr", "Zubenelgenubi",
    ],
    setupListDocumentEndpoint: [],
    setupListMetaDocumentEndpoint: [],
    setupListCommunityGraphEndpoint: [],
    setupListMetaCommunityGraphEndpoint: [],
    DDModelShow: [],
    modelDataList: [],
    listAzureEndpointFastMode: [],
    setupOpenIDConnectList: [],
    summaryAgentList: [],
    gptModelList: [],
    setup: {
      azureOpenAI_URL: null,
      azureOpenAI_APIKey: null,
      azureStorageConnection: null,
      Show_AzureStorageConnection: false,
      azureContainer: null,
      azureStorageConnectionCif: null,
      Show_AzureStorageConnectionCif: false,
      azureContainerCif: null,
      azureStorageConnectionPDFVector: null,
      Show_AzureStorageConnectionPDFVector: false,
      azureContainerPDFVector: null,
      azureStorageConnectionImage: null,
      Show_AzureStorageConnectionImage: false,
      azureContainerImage: null,
      azureStorageSpeech: null,
      Show_AzureStorageSpeech: false,
      azureContainerSpeech: null,
      azureQuickReplyIconStorage: null,
      Show_AzureQuickReplyIconStorage: false,
      azureQuickReplyIconContainer: null,
      azureGeniePrefixStorage: null,
      Show_AzureGeniePrefixStorage: false,
      azureGeniePrefixContainer: null,
      languageTranslatorKey: null,
      Show_LanguageTranslatorKey: false,
      languageTranslatorEndpoint: null,
      languageTranslatorLocation: null,
      languageKey: null,
      Show_LanguageKey: false,
      languageEndpoint: null,
      channelSecretInternal: null,
      channelTokenInternal: null,
      emailHost: null,
      smtpHost: '',
      smtpPort: 587,
      emailSendMode: 'smtp',
      acsEmailConnectionString: '',
      Show_AcsEmailConnectionString: false,
      acsEmailEndpoint: '',
      hostName: null,
      password: null,
      Show_Password: false,
      openAIAPIKey: null,
      Show_OpenAI_APIKey: false,
      openAIUrl: null,
      speechToTextEndpoint: null,
      speechToTextUseEndpointIOS: false,
      speechToTextUseEndpointAndroid: false,
      speechToTextKey: null,
      Show_SpeechToTextKey: false,
      speechToTextRegion: null,
      speechToTextLanguage: null,
      googleSttEndpoint: '',
      googleSttLocation: '',
      googleSttModel: '',
      textToSpeech: null,
      pathFFMpeg: null,
      pathFFMpegLocal: null,
      autoStream: null,
      anonymous: null,
      // Call Center — สวิตช์ log MIAW/webhook (docs/Social-Api-Log-Plan.md)
      socialApiLogEnabled: false,
      socialApiLogBodyEnabled: false,
      socialApiLogRetentionDays: '7',
      socialApiLogMaxBodyKB: '64',
      socialApiLogRowRetentionDays: '90',
      TimeDelayCharacter: null,
      LimitedCharacter: null,
      AzureOpenAIEmbeding_Url: null,
      AzureOpenAIEmbeding_APIKey: null,
      Show_AzureOpenAI_APIKey: false,
      azureOpenAIEmbeding_APIVersion: null,
      AzureOpenAI_EmbedingType: null,
      endpointSuspenseMinutes: '30',
      endpointSuspenseFailCount: '3',
      projectID: null,
      locationID: null,
      geminiTimeout: '30',
      geminiMaxRetry: '3',
      llmTimeout: '30',
      legacyMaxTokensModels: [],
      entityExtractionMaxTokens: '2000',
      communityGraphMaxTokens: '350',
      autoChunkMaxTokens: '1000',
      autoChunkMaxChunkSize: '5000',
      fileJSON: null,
      amazonClaude_APIKey: null,
      Show_AmazonClaude_APIKey: false,
      GPTMode: '0',
      GPTRepeatTime: null,
      Model: null,
      Questions: null,
      SSO: null,
      SSOChat: null,
      instance: null,
      domain: null,
      tenantId: null,
      clientId: null,
      callbackPath: null,
      clientSecret: null,
      APIScope: null,
      URLConfig: null,
      SecurityGroupTenantID: null,
      Show_SecurityGroupTenantID: false,
      SecurityGroupClientID: null,
      Show_SecurityGroupClientID: false,
      SecurityGroupClientSecrete: null,
      Show_SecurityGroupClientSecrete: false,
      FlagAutoDisableGPT: null,
      FlagDisableGPT: null,
      AutoDisableGPTPeriodDate: null,
      AutoDisableGPTMessage: null,
      AutoDisableGPTPricing: null,
    },
    secretKey: '01234567890123456789012345678901',
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    azureOpenAI_EmbedingType_List: [
      { text: 'text-embedding-3-large', value: 'text-embedding-3-large' },
      { text: 'text-embedding-3-small', value: 'text-embedding-3-small' },
      { text: 'text-embedding-ada-002', value: 'text-embedding-ada-002' },
      { text: 'bge-m3', value: 'bge-m3' },
    ],
    myClipboard: '',
    myClipboardFullSteam: '',
    urlApi: import.meta.env.VITE_APP_API,
    tempFileJSON: null,
    isUploadFileJSON: false,
    syncSSO: false,
  }),
  watch: {
    syncSSO: {
      handler(val) {
        let self = this;
        if (val) {
          let ConfigData = self.setupOpenIDConnectList.find((item) => item.provider == 'Microsoft');
          self.setup.SecurityGroupTenantID = ConfigData.tenantId;
          self.setup.SecurityGroupClientID = ConfigData.clientId;
          self.setup.SecurityGroupClientSecrete = ConfigData.clientSecret;
        }
      },
      deep: true,
      immediate: true,
    },
    setupOpenIDConnectList: {
      handler(val) {
        let self = this;
        const newItem = val.find((item) => item.provider === 'Microsoft');
        if (self.syncSSO == true) {
          self.setup.SecurityGroupTenantID = newItem.tenantId;
          self.setup.SecurityGroupClientID = newItem.clientId;
          self.setup.SecurityGroupClientSecrete = newItem.clientSecret;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.GetDate();
    this.Get();
    this.GetModelData();
    this.GetDDLModelDataAzureProvider();
    this.myClipboard = `<script src="${this.urlApi}Snippet/ChatFrameworkSnippet.js"><` + '/script>';
    this.myClipboardFullSteam = `<script src="${this.urlApi}Snippet/ChatFrameworkSnippetFull.js"><` + '/script>';
    const scroller = document.querySelector('.v-main__scroller') || window;
    scroller.addEventListener('scroll', this.handleScroll, true);
    this._scrollContainer = scroller;
  },
  unmounted() {
    // ลบ listener ออกจาก container ที่แท้จริง
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener('scroll', this.handleScroll, true);
    }
  },

  computed: {
    // Same URL GoogleSttV2TokenProvider.BuildEndpoint makes when the Endpoint box is empty:
    // project = project_id in the JSON credential, Project ID box only if the JSON has none
    googleSttDefaultEndpoint() {
      let jsonProject = null;
      try {
        jsonProject = this.setup.fileJSON ? JSON.parse(this.setup.fileJSON)?.project_id : null;
      } catch (e) {
        jsonProject = null;
      }
      const project = jsonProject || this.setup.projectID || '{projectId}';
      const location = (this.setup.googleSttLocation || 'us').trim();
      const host = location === 'global' ? 'speech.googleapis.com' : `${location}-speech.googleapis.com`;
      return `https://${host}/v2/projects/${project}/locations/${location}/recognizers/_:recognize`;
    },
    smtpProvider: {
      get() {
        if (this.smtpCustom) return 'custom';
        // An unset host means the backend falls back to Office 365, so show that.
        const host = String(this.setup.smtpHost || 'smtp.office365.com').trim().toLowerCase();
        return this.smtpPresets.some((preset) => preset.value === host) ? host : 'custom';
      },
      set(value) {
        this.smtpCustom = value === 'custom';
        if (this.smtpCustom) return;
        const preset = this.smtpPresets.find((item) => item.value === value);
        if (!preset) return;
        this.setup.smtpHost = preset.value;
        this.setup.smtpPort = preset.port;
      },
    },
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('Setup');
    },
    form() {
      return {
        id: this.user.id,
        key: this.user.key,
        value: this.user.value,
      };
    },
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'center',
          value: 'priority',
          sortable: false,
        },
        {
          title: 'AzureOpenAIUrl',
          value: 'azureOpenAIUrl',
          align: 'left',
          sortable: true,
        },
        {
          title: 'ResponseTime (Milliseconds)',
          value: 'responseTime',
          align: 'left',
          sortable: true,
        },
        { title: 'Answers', value: 'replytext', align: 'left', sortable: true },
      ];
    },
    aiProcessingSections() {
      return [
        { key: 'Document', title: 'Document Endpoints', list: this.setupListDocumentEndpoint },
        { key: 'MetaDocument', title: 'MetaDocument Endpoints', list: this.setupListMetaDocumentEndpoint },
        { key: 'CommunityGraph', title: 'Community Graph Endpoints', list: this.setupListCommunityGraphEndpoint },
        { key: 'MetaCommunityGraph', title: 'Meta Community Graph Endpoints', list: this.setupListMetaCommunityGraphEndpoint },
      ];
    },
    uniqueModelDataList() {
      let modelMap = new Map();
      this.modelDataList.forEach((item) => {
        if (item.modelName && !modelMap.has(item.modelName)) {
          modelMap.set(item.modelName, item);
        }
      });
      return Array.from(modelMap.values());
    },
  },

  methods: {
    handleScroll(event) {
      const { scrollTop } = event.target;
      if (scrollTop >= this.scrollThreshold) {
        this.showStickySaveButton = true;
      } else {
        this.showStickySaveButton = false;
      }
    },
    Apply() {
      try {
        let self = this;
        self.dialog = true;
        self.$call.GetSetupApply(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              // self.Get();
              alert('Apply change');
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) {
        this.LogTrace(error, 'Apply');
      }
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    setListAzureEndpointFastMode(data) {
      let self = this;
      let newList = data.sort((a, b) => a.priority - b.priority);
      let checkfastmode = data.filter((item) => item.responseTime !== null);
      if (checkfastmode.length == newList.length) {
        self.listAzureEndpointFastMode = newList.map((item) => {
          return {
            priority: item.priority,
            azureOpenAIUrl: item.azureOpenAIUrl,
            responseTime: item.responseTime == 0 ? '-' : item.responseTime,
            replytext: item.replytext,
          };
        });
      } else {
        self.listAzureEndpointFastMode = [];
      }
    },
    setListOpenIDConnect(data) {
      let self = this;
      self.setupOpenIDConnectList = data.map((item) => {
        return {
          provider: item.provider,
          sso: item.sso,
          ssoChat: item.ssoChat,
          instance: item.instance,
          domain: item.domain,
          tenantId: item.tenantId,
          Show_TenantId: false,
          clientId: item.clientId,
          Show_ClientId: false,
          callbackPath: item.callbackPath,
          clientSecret: item.clientSecret,
          Show_ClientSecret: false,
          apiScope: item.apiScope,
          Show_APIScope: false,
          urlConfig: item.urlConfig,
        };
      });
    },
    Get() {
      try {
        let self = this;
        self.$call.GetSetupOverviewGeneral(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.setupList = dataResponse.data.listDbsettings;
              self.EnsureSetupKeys();
              if (dataResponse.data.listAzureOpenAIEndpoint.length == 0) {
                self.listAzureEndpointFastMode = [];
                self.Add();
              } else {
                self.setupListAzureOpenAIEndpoint = dataResponse.data.listAzureOpenAIEndpoint.map((item) => ({
                  ...item,
                  showValue: false, // เพิ่ม key ใหม่ "showValue"
                }));
                // self.setupListAzureOpenAIEndpoint = dataResponse.data.listAzureOpenAIEndpoint;
                self.setListAzureEndpointFastMode(dataResponse.data.listAzureOpenAIEndpoint);
              }

              // Load Gemini Locations
              if (dataResponse.data.listGeminiLocation && dataResponse.data.listGeminiLocation.length > 0) {
                self.setupListGeminiLocation = dataResponse.data.listGeminiLocation;
              } else {
                self.setupListGeminiLocation = [];
              }

              if (dataResponse.data.listTextToSpeechConfiguration && dataResponse.data.listTextToSpeechConfiguration.length > 0) {
                self.setupListTextToSpeech = dataResponse.data.listTextToSpeechConfiguration.map((item) => ({
                  id: item.id,
                  endpoint: item.endpoint,
                  apiKey: item.apiKey,
                  region: item.region,
                  showValue: false,
                }));
              } else {
                self.setupListTextToSpeech = [];
              }

              if (dataResponse.data.listGeminiTextToSpeechConfiguration && dataResponse.data.listGeminiTextToSpeechConfiguration.length > 0) {
                self.geminiTtsList = dataResponse.data.listGeminiTextToSpeechConfiguration.map((item) => ({
                  id: item.id,
                  endpoint: item.endpoint,
                  endpointLocked: true,
                  accessToken: item.apiKey,
                  location: item.region,
                  model: item.model,
                  instruction: item.instruction,
                  voiceNameEn: item.voiceNameEn,
                  voiceNameTh: item.voiceNameTh,
                  voiceNameCn: item.voiceNameCn,
                  showToken: false,
                }));
              }

              self.setupListDocumentEndpoint = self.mapAIProcessingEndpoints(
                dataResponse.data.listDocumentEndpoint
              );
              self.setupListMetaDocumentEndpoint = self.mapAIProcessingEndpoints(
                dataResponse.data.listMetaDocumentEndpoint
              );
              self.setupListCommunityGraphEndpoint = self.mapAIProcessingEndpoints(
                dataResponse.data.listCommunityGraphEndpoint
              );
              self.setupListMetaCommunityGraphEndpoint = self.mapAIProcessingEndpoints(
                dataResponse.data.listMetaCommunityGraphEndpoint
              );

              if (dataResponse.data.listOpenIDConnect.length == 0) {
                self.AddOpenIDConnect('Microsoft');
                self.AddOpenIDConnect('Authentik');
                self.AddOpenIDConnect('Line');
              } else {
                self.setListOpenIDConnect(dataResponse.data.listOpenIDConnect);

                if (self.setupOpenIDConnectList.filter((item) => item.provider == 'Microsoft').length == 0) {
                  self.AddOpenIDConnect('Microsoft');
                } else if (self.setupOpenIDConnectList.filter((item) => item.provider == 'Authentik').length == 0) {
                  self.AddOpenIDConnect('Authentik');
                } else if (self.setupOpenIDConnectList.filter((item) => item.provider == 'Line').length == 0) {
                  self.AddOpenIDConnect('Line');
                }
              }

              self.MapSetupList(self.setupList, false);
              self.GetGPTModels();
              self.GetSummaryAgents();
            }
            self.dialog = false;
            self.isSearch = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'Get');
      }
    },
    EnsureSetupKeys() {
      const requiredKeys = [
        'SpeechToTextEndpoint',
        'SpeechToTextUseEndpointIOS',
        'SpeechToTextUseEndpointAndroid',
        'GoogleSttEndpoint',
        'GoogleSttLocation',
        'GoogleSttModel',
        'EndpointSuspenseMinutes',
        'EndpointSuspenseFailCount',
        'LLMTimeout',
        'LegacyMaxTokensModels',
        'EntityExtraction_MaxTokens',
        'CommunityGraph_MaxTokens',
        'AutoChunk_MaxTokens',
        'AutoChunk_MaxChunkSize',
        'AzureGeniePrefixStorage',
        'AzureGeniePrefixContainer',
        'SocialApiLogEnabled',
        'SocialApiLogBodyEnabled',
        'SocialApiLogRetentionDays',
        'SocialApiLogMaxBodyKB',
        'SocialApiLogRowRetentionDays',
        'SmtpHost',
        'SmtpPort',
        'EmailSendMode',
        'AcsEmailConnectionString',
        'AcsEmailEndpoint',
      ];
      requiredKeys.forEach((key) => {
        if (!this.setupList.some((item) => item.key === key)) {
          const defaultValues = {
            SpeechToTextEndpoint: '',
            SpeechToTextUseEndpointIOS: 'false',
            SpeechToTextUseEndpointAndroid: 'false',
            // ว่าง = backend ใช้ค่า default ใน GoogleSttV2TokenProvider (endpoint จาก project_id ใน JSON / us / chirp_3)
            GoogleSttEndpoint: '',
            GoogleSttLocation: 'us',
            GoogleSttModel: 'chirp_3',
            EndpointSuspenseMinutes: '30',
            EndpointSuspenseFailCount: '3',
            LLMTimeout: '30',
            LegacyMaxTokensModels: '',
            EntityExtraction_MaxTokens: '2000',
            CommunityGraph_MaxTokens: '350',
            AutoChunk_MaxTokens: '1000',
            // ⚠️ ต้องตรงกับ default ใน AutoChunkConfigService.GetConfig (MaxChunkSize = 5000)
            AutoChunk_MaxChunkSize: '5000',
            AzureGeniePrefixStorage: '',
            AzureGeniePrefixContainer: '',
            // ⚠️ ต้องตรงกับ docs/sql/20260817/CreateCallCenterSchema.sql และ SocialApiLogSwitch.cs
            //    ทั้งสองสวิตช์เริ่มที่ปิด — เผลอเปิดแปลว่าเริ่มเก็บบทสนทนาลูกค้าโดยไม่มีใครตั้งใจ
            SocialApiLogEnabled: 'false',
            SocialApiLogBodyEnabled: 'false',
            SocialApiLogRetentionDays: '7',
            SocialApiLogMaxBodyKB: '64',
            SocialApiLogRowRetentionDays: '90',
            // ว่าง = ให้ SentMailBAL ตกกลับไป smtp.office365.com:587 เหมือนเดิม
            SmtpHost: '',
            SmtpPort: '587',
            // smtp = ส่งผ่าน SMTP เหมือนเดิม จนกว่าจะเลือกโหมด Azure Communication Services
            EmailSendMode: 'smtp',
            AcsEmailConnectionString: '',
            AcsEmailEndpoint: '',
          };
          this.setupList.push({
            id: 0,
            key,
            value: defaultValues[key],
            activeFlag: true,
          });
        }
      });
    },
    /**
     * บีบค่าให้อยู่ในช่วงเดียวกับ SocialApiLogSwitch.ReadInt ฝั่ง .NET
     *
     * ⚠️ ต้อง clamp ที่นี่ด้วย ไม่ใช่ปล่อยให้ฝั่ง server บีบอย่างเดียว —
     *    ถ้าไม่ทำ คนกรอก 9999 จะเห็นเลข 9999 ค้างในหน้าจอตลอด ทั้งที่ระบบใช้ 365
     *    แล้วสรุปผิดว่าตั้งค่าไว้แล้วแต่ retention ไม่ทำงาน
     */
    ClampSetting(raw, min, max, fallback) {
      const n = parseInt(raw, 10);
      if (isNaN(n)) return String(fallback);
      return String(n < min ? min : n > max ? max : n);
    },
    ParseBooleanSetting(value) {
      return value === true || value === 'true' || value === 'True' || value === '1';
    },
    MapSetupList(source, mapForSave) {
      let self = this;
      source.forEach((element) => {
        switch (element.key) {
          case 'AzureContainer':
            element.value = mapForSave ? self.setup.azureContainer : element.value;
            self.setup.azureContainer = element.value;
            break;
          case 'AzureStorageConnectionCif':
            element.value = mapForSave ? self.setup.azureStorageConnectionCif : element.value;
            self.setup.azureStorageConnectionCif = element.value;
            break;
          case 'AzureContainerCif':
            element.value = mapForSave ? self.setup.azureContainerCif : element.value;
            self.setup.azureContainerCif = element.value;
            break;
          case 'AzureContainerPDFVector':
            element.value = mapForSave ? self.setup.azureContainerPDFVector : element.value;
            self.setup.azureContainerPDFVector = element.value;
            break;
          case 'AzureContainerImage':
            element.value = mapForSave ? self.setup.azureContainerImage : element.value;
            self.setup.azureContainerImage = element.value;
            break;
          case 'AzureOpenAI_APIKey':
            element.value = mapForSave ? self.setup.azureOpenAI_APIKey : element.value;
            self.setup.azureOpenAI_APIKey = element.value;
            break;
          case 'AzureOpenAI_Url':
            element.value = mapForSave ? self.setup.azureOpenAI_URL : element.value;
            self.setup.azureOpenAI_URL = element.value;
            break;
          case 'AzureOpenAIEmbeding_APIKey':
            element.value = mapForSave ? self.setup.AzureOpenAIEmbeding_APIKey : element.value;
            self.setup.AzureOpenAIEmbeding_APIKey = element.value;
            break;
          case 'AzureOpenAIEmbeding_Url':
            element.value = mapForSave ? self.setup.AzureOpenAIEmbeding_Url : element.value;
            self.setup.AzureOpenAIEmbeding_Url = element.value;
            break;
          case 'AzureOpenAIEmbeding_APIVersion':
            element.value = mapForSave ? self.setup.AzureOpenAIEmbeding_APIVersion : element.value;
            self.setup.AzureOpenAIEmbeding_APIVersion = element.value;
            break;
          case 'AzureOpenAI_EmbedingType':
            element.value = mapForSave ? self.setup.AzureOpenAI_EmbedingType : element.value;
            self.setup.AzureOpenAI_EmbedingType = element.value;
            break;
          case 'EndpointSuspenseMinutes':
            element.value = mapForSave ? self.setup.endpointSuspenseMinutes : element.value;
            self.setup.endpointSuspenseMinutes = element.value || '30';
            break;
          case 'EndpointSuspenseFailCount':
            element.value = mapForSave ? self.setup.endpointSuspenseFailCount : element.value;
            self.setup.endpointSuspenseFailCount = element.value || '3';
            break;
          case 'AzureStorageConnection':
            element.value = mapForSave ? self.setup.azureStorageConnection : element.value;
            self.setup.azureStorageConnection = element.value;
            break;
          case 'AzureStorageConnectionPDFVector':
            element.value = mapForSave ? self.setup.azureStorageConnectionPDFVector : element.value;
            self.setup.azureStorageConnectionPDFVector = element.value;
            break;
          case 'AzureStorageConnectionImage':
            element.value = mapForSave ? self.setup.azureStorageConnectionImage : element.value;
            self.setup.azureStorageConnectionImage = element.value;
            break;
          case 'AzureStorageSpeech':
            element.value = mapForSave ? self.setup.azureStorageSpeech : element.value;
            self.setup.azureStorageSpeech = element.value;
            break;
          case 'AzureContainerSpeech':
            element.value = mapForSave ? self.setup.azureContainerSpeech : element.value;
            self.setup.azureContainerSpeech = element.value;
            break;
          case 'AzureQuickReplyIconStorage':
            element.value = mapForSave ? self.setup.azureQuickReplyIconStorage : element.value;
            self.setup.azureQuickReplyIconStorage = element.value;
            break;
          case 'AzureQuickReplyIconContainer':
            element.value = mapForSave ? self.setup.azureQuickReplyIconContainer : element.value;
            self.setup.azureQuickReplyIconContainer = element.value;
            break;
          case 'AzureGeniePrefixStorage':
            element.value = mapForSave ? self.setup.azureGeniePrefixStorage : element.value;
            self.setup.azureGeniePrefixStorage = element.value;
            break;
          case 'AzureGeniePrefixContainer':
            element.value = mapForSave ? self.setup.azureGeniePrefixContainer : element.value;
            self.setup.azureGeniePrefixContainer = element.value;
            break;
          // case "ChannelSecret_Internal":
          //   element.value = mapForSave
          //     ? self.setup.channelSecretInternal
          //     : element.value;
          //   self.setup.channelSecretInternal = element.value;
          //   break;
          // case "ChannelToken_Internal":
          //   element.value = mapForSave
          //     ? self.setup.channelTokenInternal
          //     : element.value;
          //   self.setup.channelTokenInternal = element.value;
          //   break;
          case 'EmailHost':
            element.value = mapForSave ? self.setup.emailHost : element.value;
            self.setup.emailHost = element.value;
            break;
          case 'HostName':
            element.value = mapForSave ? self.setup.hostName : element.value;
            self.setup.hostName = element.value;
            break;
          case 'SmtpHost':
            element.value = mapForSave ? String(self.setup.smtpHost || '').trim() : element.value;
            if (!mapForSave) {
              self.setup.smtpHost = element.value || '';
              const host = String(element.value || '').trim().toLowerCase();
              self.smtpCustom = !!host && !self.smtpPresets.some((preset) => preset.value === host);
            }
            break;
          case 'SmtpPort':
            element.value = mapForSave ? String(parseInt(self.setup.smtpPort, 10) || 587) : element.value;
            if (!mapForSave) self.setup.smtpPort = parseInt(element.value, 10) || 587;
            break;
          case 'EmailSendMode':
            element.value = mapForSave ? self.setup.emailSendMode || 'smtp' : element.value;
            if (!mapForSave) self.setup.emailSendMode = self.emailSendModes.some((mode) => mode.value === element.value) ? element.value : 'smtp';
            break;
          case 'AcsEmailConnectionString':
            element.value = mapForSave ? String(self.setup.acsEmailConnectionString || '').trim() : element.value;
            if (!mapForSave) self.setup.acsEmailConnectionString = element.value || '';
            break;
          case 'AcsEmailEndpoint':
            element.value = mapForSave ? String(self.setup.acsEmailEndpoint || '').trim() : element.value;
            if (!mapForSave) self.setup.acsEmailEndpoint = element.value || '';
            break;
          case 'LanguageEndpoint':
            element.value = mapForSave ? self.setup.languageEndpoint : element.value;
            self.setup.languageEndpoint = element.value;
            break;
          case 'LanguageKey':
            element.value = mapForSave ? self.setup.languageKey : element.value;
            self.setup.languageKey = element.value;
            break;
          case 'LanguageTranslatorEndpoint':
            element.value = mapForSave ? self.setup.languageTranslatorEndpoint : element.value;
            self.setup.languageTranslatorEndpoint = element.value;
            break;
          case 'LanguageTranslatorKey':
            element.value = mapForSave ? self.setup.languageTranslatorKey : element.value;
            self.setup.languageTranslatorKey = element.value;
            break;
          case 'LanguageTranslatorLocation':
            element.value = mapForSave ? self.setup.languageTranslatorLocation : element.value;
            self.setup.languageTranslatorLocation = element.value;
            break;
          case 'Password':
            element.value = mapForSave ? self.setup.password : element.value;
            self.setup.password = element.value;
            break;
          case 'OpenAI_Url':
            element.value = mapForSave ? self.setup.openAIUrl : element.value;
            self.setup.openAIUrl = element.value;
            break;
          case 'OpenAI_APIKey':
            element.value = mapForSave ? self.setup.openAIAPIKey : element.value;
            self.setup.openAIAPIKey = element.value;
            break;
          case 'SpeechToTextKey':
            element.value = mapForSave ? self.setup.speechToTextKey : element.value;
            self.setup.speechToTextKey = element.value;
            break;
          case 'SpeechToTextEndpoint':
            element.value = mapForSave ? self.setup.speechToTextEndpoint : element.value;
            self.setup.speechToTextEndpoint = element.value;
            break;
          case 'SpeechToTextUseEndpointIOS':
            element.value = mapForSave ? String(self.setup.speechToTextUseEndpointIOS) : element.value;
            self.setup.speechToTextUseEndpointIOS = self.ParseBooleanSetting(element.value);
            break;
          case 'SpeechToTextUseEndpointAndroid':
            element.value = mapForSave ? String(self.setup.speechToTextUseEndpointAndroid) : element.value;
            self.setup.speechToTextUseEndpointAndroid = self.ParseBooleanSetting(element.value);
            break;
          case 'SpeechToTextRegion':
            element.value = mapForSave ? self.setup.speechToTextRegion : element.value;
            self.setup.speechToTextRegion = element.value;
            break;
          case 'SpeechToTextLanguage':
            element.value = mapForSave ? self.setup.speechToTextLanguage : element.value;
            self.setup.speechToTextLanguage = element.value;
            break;
          case 'GoogleSttEndpoint':
            element.value = mapForSave ? (self.setup.googleSttEndpoint || '').trim() : element.value;
            self.setup.googleSttEndpoint = element.value || '';
            break;
          case 'GoogleSttLocation':
            element.value = mapForSave ? (self.setup.googleSttLocation || '').trim() : element.value;
            self.setup.googleSttLocation = element.value || '';
            break;
          case 'GoogleSttModel':
            element.value = mapForSave ? (self.setup.googleSttModel || '').trim() : element.value;
            self.setup.googleSttModel = element.value || '';
            break;
          case 'PathFFMpeg':
            element.value = mapForSave ? self.setup.pathFFMpeg : element.value;
            self.setup.pathFFMpeg = element.value;
            break;
          case 'PathFFMpegLocal':
            element.value = mapForSave ? self.setup.pathFFMpegLocal : element.value;
            self.setup.pathFFMpegLocal = element.value;
            break;
          case 'AutoStream':
            element.value = mapForSave ? (self.setup.autoStream ? '1' : '0') : element.value == '1';
            self.setup.autoStream = element.value;
            break;
          case 'Anonymous':
            element.value = mapForSave ? (self.setup.anonymous ? '1' : '0') : element.value == '1';
            self.setup.anonymous = element.value;
            break;
          case 'TimeDelayCharacter':
            element.value = mapForSave ? self.setup.TimeDelayCharacter : element.value;
            self.setup.TimeDelayCharacter = element.value;
            break;
          case 'LimitedCharacter':
            element.value = mapForSave ? self.setup.LimitedCharacter || '5000' : element.value;
            self.setup.LimitedCharacter = element.value;
            break;
          case 'FlagAutoDisableGPT':
            element.value = mapForSave ? (self.setup.FlagAutoDisableGPT ? '1' : '0') : element.value == '1';
            self.setup.FlagAutoDisableGPT = element.value;
            break;
          case 'FlagDisableGPT':
            element.value = mapForSave ? (self.setup.FlagDisableGPT ? '1' : '0') : element.value == '1';
            self.setup.FlagDisableGPT = element.value;
            break;
          case 'AutoDisableGPTPeriodDate':
            element.value = mapForSave ? self.setup.AutoDisableGPTPeriodDate : element.value;
            self.setup.AutoDisableGPTPeriodDate = element.value;
            break;
          case 'AutoDisableGPTMessage':
            element.value = mapForSave ? self.setup.AutoDisableGPTMessage : element.value;
            self.setup.AutoDisableGPTMessage = element.value;
            break;
          case 'AutoDisableGPTPricing':
            element.value = mapForSave ? self.setup.AutoDisableGPTPricing : element.value;
            self.setup.AutoDisableGPTPricing = element.value;
            break;
          case 'ProjectID':
            element.value = mapForSave ? self.setup.projectID : element.value;
            self.setup.projectID = element.value;
            break;
          case 'LocationID':
            element.value = mapForSave ? self.setup.locationID : element.value;
            self.setup.locationID = element.value;
            break;
          case 'GeminiTimeout':
            element.value = mapForSave ? self.setup.geminiTimeout : element.value;
            self.setup.geminiTimeout = element.value || '30';
            break;
          case 'GeminiMaxRetry':
            element.value = mapForSave ? self.setup.geminiMaxRetry : element.value;
            self.setup.geminiMaxRetry = element.value || '3';
            break;
          case 'LLMTimeout':
            element.value = mapForSave ? self.setup.llmTimeout : element.value;
            self.setup.llmTimeout = element.value || '30';
            break;
          case 'LegacyMaxTokensModels':
            if (mapForSave) {
              element.value = Array.isArray(self.setup.legacyMaxTokensModels) ? self.setup.legacyMaxTokensModels.join(',') : self.setup.legacyMaxTokensModels || '';
            } else {
              self.setup.legacyMaxTokensModels = element.value
                ? element.value
                    .split(',')
                    .map((s) => s.trim())
                    .filter((s) => s)
                : [];
              self.NormalizeLegacyMaxTokensModels();
            }
            break;
          case 'EntityExtraction_MaxTokens':
            element.value = mapForSave ? self.setup.entityExtractionMaxTokens : element.value;
            self.setup.entityExtractionMaxTokens = element.value || '2000';
            break;
          case 'CommunityGraph_MaxTokens':
            element.value = mapForSave ? self.setup.communityGraphMaxTokens : element.value;
            self.setup.communityGraphMaxTokens = element.value || '350';
            break;
          case 'AutoChunk_MaxTokens':
            element.value = mapForSave ? self.setup.autoChunkMaxTokens : element.value;
            self.setup.autoChunkMaxTokens = element.value || '1000';
            break;
          // ใช้ร่วมกันทั้งการตัด chunk Meta-Document และข่าว (NewsSyncService.SplitBodiesAsync)
          case 'AutoChunk_MaxChunkSize':
            element.value = mapForSave ? self.ClampSetting(self.setup.autoChunkMaxChunkSize, 500, 20000, 5000) : element.value;
            self.setup.autoChunkMaxChunkSize = element.value || '5000';
            break;
          // ── Call Center · log MIAW/webhook · docs/Social-Api-Log-Plan.md ──────────
          // ⚠️ เขียนเป็น 'true'/'false' ให้ตรงกับที่ CreateCallCenterSchema.sql seed ไว้
          //    ฝั่ง .NET รับทั้ง 'true' และ '1' แต่ถ้าเขียนคนละแบบกัน คนที่เปิดตารางดูจะ
          //    แยกไม่ออกว่าแถวไหนคือค่าจริง
          case 'SocialApiLogEnabled':
            element.value = mapForSave ? String(self.setup.socialApiLogEnabled) : element.value;
            self.setup.socialApiLogEnabled = self.ParseBooleanSetting(element.value);
            break;
          case 'SocialApiLogBodyEnabled':
            element.value = mapForSave ? String(self.setup.socialApiLogBodyEnabled) : element.value;
            self.setup.socialApiLogBodyEnabled = self.ParseBooleanSetting(element.value);
            break;
          case 'SocialApiLogRetentionDays':
            element.value = mapForSave ? self.ClampSetting(self.setup.socialApiLogRetentionDays, 1, 365, 7) : element.value;
            self.setup.socialApiLogRetentionDays = element.value || '7';
            break;
          case 'SocialApiLogMaxBodyKB':
            element.value = mapForSave ? self.ClampSetting(self.setup.socialApiLogMaxBodyKB, 1, 1024, 64) : element.value;
            self.setup.socialApiLogMaxBodyKB = element.value || '64';
            break;
          case 'SocialApiLogRowRetentionDays':
            element.value = mapForSave ? self.ClampSetting(self.setup.socialApiLogRowRetentionDays, 1, 365, 90) : element.value;
            self.setup.socialApiLogRowRetentionDays = element.value || '90';
            break;
          case 'FileJSON':
            element.value = mapForSave ? self.setup.fileJSON : element.value;
            self.setup.fileJSON = element.value;
            if (self.setup.fileJSON != null && self.setup.fileJSON != '' && self.setup.fileJSON != undefined) {
              self.isUploadFileJSON = true;
            }
            break;
          case 'AmazonClaude_APIKey':
            element.value = mapForSave ? self.setup.amazonClaude_APIKey : element.value;
            self.setup.amazonClaude_APIKey = element.value;
            break;
          case 'GPTMode':
            element.value = mapForSave ? (self.setup.GPTMode ? '1' : '0') : element.value == '1';
            self.setup.GPTMode = element.value;
            break;
          case 'GPTRepeatTime':
            element.value = mapForSave ? (self.setup.GPTMode == '0' ? null : self.setup.GPTRepeatTime) : self.setup.GPTMode == '0' ? null : element.value;
            self.setup.GPTRepeatTime = element.value;
            break;
          case 'Model':
            element.value = mapForSave ? (self.setup.GPTMode == '0' ? null : self.setup.Model) : self.setup.GPTMode == '0' ? null : element.value;
            self.setup.Model = element.value;
            break;
          case 'Questions':
            element.value = mapForSave ? (self.setup.GPTMode == '0' ? null : self.setup.Questions) : self.setup.GPTMode == '0' ? null : element.value;
            self.setup.Questions = element.value;
            break;
          case 'SSO':
            element.value = mapForSave ? (self.setup.SSO ? '1' : '0') : element.value == '1';
            self.setup.SSO = element.value;
            break;
          case 'SSOChat':
            element.value = mapForSave ? (self.setup.SSOChat ? '1' : '0') : element.value == '1';
            self.setup.SSOChat = element.value;
            break;
          case 'Instance':
            element.value = mapForSave ? self.setup.instance : element.value;
            self.setup.instance = element.value;
            break;
          case 'Domain':
            element.value = mapForSave ? self.setup.domain : element.value;
            self.setup.domain = element.value;
            break;
          case 'TenantId':
            element.value = mapForSave ? self.setup.tenantId : element.value;
            self.setup.tenantId = element.value;
            break;
          case 'ClientId':
            element.value = mapForSave ? self.setup.clientId : element.value;
            self.setup.clientId = element.value;
            break;
          case 'CallbackPath':
            element.value = mapForSave ? self.setup.callbackPath : element.value;
            self.setup.callbackPath = element.value;
            break;
          case 'ClientSecret':
            element.value = mapForSave ? self.setup.clientSecret : element.value;
            self.setup.clientSecret = element.value;
            break;
          case 'APIScope':
            element.value = mapForSave ? self.setup.APIScope : element.value;
            self.setup.APIScope = element.value;
            break;
          case 'URLConfig':
            element.value = mapForSave ? self.setup.URLConfig : element.value;
            self.setup.URLConfig = element.value;
            break;
          case 'SecurityGroupTenantID':
            element.value = mapForSave ? self.setup.SecurityGroupTenantID : element.value;
            self.setup.SecurityGroupTenantID = element.value;
            break;
          case 'SecurityGroupClientID':
            element.value = mapForSave ? self.setup.SecurityGroupClientID : element.value;
            self.setup.SecurityGroupClientID = element.value;
            break;
          case 'SecurityGroupClientSecrete':
            element.value = mapForSave ? self.setup.SecurityGroupClientSecrete : element.value;
            self.setup.SecurityGroupClientSecrete = element.value;
            break;
          default:
            break;
        }
      });
    },
    EditUser(temp) {
      let self = this;
      self.edit.id = temp.id;
      self.edit.key = temp.key;
      self.edit.value = temp.value;

      self.Editdialog = true;
    },
    ValidatesetupListAzureOpenAIEndpoint() {
      let self = this;
      if (self.setupListAzureOpenAIEndpoint.length == 0) {
        return false;
      }
      for (let i = 0; i < self.setupListAzureOpenAIEndpoint.length; i++) {
        let item = self.setupListAzureOpenAIEndpoint[i];
        if (
          item.priorityDisplay == 0 ||
          item.priorityDisplay == '' ||
          item.priorityDisplay == null ||
          item.azureOpenAIUrl == '' ||
          item.azureOpenAIUrl == null ||
          item.azureOpenAIAPIKey == '' ||
          item.azureOpenAIAPIKey == null
        ) {
          return false;
        }
      }
      return true;
    },
    ValidateFastMode() {
      let self = this;
      if (self.setup.GPTMode != '1') {
        return true;
      }

      if (self.setup.GPTRepeatTime == '0' || self.setup.GPTRepeatTime == 0 || self.setup.GPTRepeatTime == null || self.setup.GPTRepeatTime == undefined) {
        return false;
      } else if (self.setup.Model == '' || self.setup.Model == null || self.setup.Model == undefined) {
        return false;
      } else if (self.setup.Questions == '' || self.setup.Questions == null || self.setup.Questions == undefined) {
        return false;
      }
      return true;
    },
    Update() {
      try {
        let self = this;
        if (!self.ValidatesetupListAzureOpenAIEndpoint() || !self.ValidateFastMode()) {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningFillAll'),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        self.dialog = true;
        self.MapSetupList(self.setupList, true);
        let req = {
          listDbsettings: self.setupList,
          listAzureOpenAIEndpoint: self.setupListAzureOpenAIEndpoint,
          listGeminiLocation: self.setupListGeminiLocation,
          listTextToSpeechConfiguration: self.setupListTextToSpeech.map((item) => ({
            id: item.id,
            endpoint: item.endpoint,
            apiKey: item.apiKey,
            region: item.region,
          })),
          listGeminiTextToSpeechConfiguration: self.geminiTtsList.map((item) => ({
            id: item.id || 0,
            endpoint: item.endpoint,
            apiKey: item.accessToken,
            region: item.location,
            model: item.model,
            instruction: item.instruction,
            voiceNameEn: item.voiceNameEn,
            voiceNameTh: item.voiceNameTh,
            voiceNameCn: item.voiceNameCn,
          })),
          listOpenIDConnect: self.setupOpenIDConnectList,
          listDocumentEndpoint: self.setupListDocumentEndpoint,
          listMetaDocumentEndpoint: self.setupListMetaDocumentEndpoint,
          listCommunityGraphEndpoint: self.setupListCommunityGraphEndpoint,
          listMetaCommunityGraphEndpoint: self.setupListMetaCommunityGraphEndpoint,
        };
        self.$call.GetSetupUpdateGeneral(
          req,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              // Update Summary Agents
              try {
                await self.UpdateSummaryAgents();
              } catch (error) {
                console.error('Error updating summary agents:', error);
              }

              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.Get();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'UpdateUser');
      }
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    copyClipboard() {
      this.$refs.clone.focus();
      document.execCommand('copy');
    },
    copyClipboardFullSteam() {
      this.$refs.cloneFullSteam.focus();
      document.execCommand('copy');
    },
    uploadFile(e) {
      let self = this;
      if (e.length > 0) {
        switch (e[0].type) {
          case 'application/json':
            self.tempFileJSON = e[0];
            console.log('fileJSON', self.tempFileJSON);
            self.readFile(self.tempFileJSON);
            break;
          default:
          // code block
        }
      }
    },
    readFile(file) {
      let self = this;
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function () {
        self.setup.fileJSON = reader.result;
        self.isUploadFileJSON = false;
        console.log('self.setup.fileJSON', self.setup.fileJSON);
        // Vertex URLs are built from Project ID, so it must match the service account's project
        let projectId = null;
        try {
          projectId = JSON.parse(reader.result)?.project_id;
        } catch (e) {
          console.warn('JSON credential is not valid JSON', e);
        }
        if (projectId) {
          self.setup.projectID = projectId;
        }
      };
      reader.onerror = function () {
        alert('Failed to read file!');
      };
    },
    Delete(index) {
      let self = this;
      self.$swal
        .fire({
          title: this.$t('confirmDeletion'),
          text: this.$t('confirmDeletionAzureOpenAI'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.setupListAzureOpenAIEndpoint.splice(index, 1);
          }
        });
    },
    Add() {
      let self = this;
      let temp = {
        id: 0,
        azureOpenAIUrl: null,
        azureOpenAIAPIKey: null,
        priorityDisplay: null,
        showValue: false,
      };
      self.setupListAzureOpenAIEndpoint.push(temp);
    },
    mapAIProcessingEndpoints(list) {
      if (!list || list.length === 0) return [];
      return list.map((item) => ({ ...item, showValue: false }));
    },
    aiProcessingListForKey(key) {
      switch (key) {
        case 'Document':
          return this.setupListDocumentEndpoint;
        case 'MetaDocument':
          return this.setupListMetaDocumentEndpoint;
        case 'CommunityGraph':
          return this.setupListCommunityGraphEndpoint;
        case 'MetaCommunityGraph':
          return this.setupListMetaCommunityGraphEndpoint;
        default:
          return [];
      }
    },
    AddAIProcessingEndpoint(key) {
      this.aiProcessingListForKey(key).push({
        id: 0,
        endpointType: key,
        azureUrl: null,
        apiKey: null,
        deployment: null,
        apiVersion: null,
        priorityDisplay: null,
        showValue: false,
      });
    },
    DeleteAIProcessingEndpoint(key, index) {
      let self = this;
      self.$swal
        .fire({
          title: self.$t('confirmDeletion'),
          text: self.$t('confirmDeletionAzureOpenAI'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: self.$t('confirm'),
          cancelButtonText: self.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.aiProcessingListForKey(key).splice(index, 1);
          }
        });
    },
    AddGeminiLocation() {
      let self = this;
      let temp = {
        id: 0,
        locationId: null,
        priorityDisplay: null,
      };
      self.setupListGeminiLocation.push(temp);
    },
    DeleteGeminiLocation(index) {
      let self = this;
      this.$swal
        .fire({
          title: this.$t('confirmDeletion'),
          text: 'Delete this Gemini Location?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.setupListGeminiLocation.splice(index, 1);
          }
        });
    },
    AddTextToSpeech() {
      this.setupListTextToSpeech.push({
        id: 0,
        endpoint: null,
        apiKey: null,
        region: null,
        showValue: false,
      });
    },
    DeleteTextToSpeech(index) {
      this.$swal
        .fire({
          title: this.$t('confirmDeletion'),
          text: 'Delete this Text to Speech configuration?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.setupListTextToSpeech.splice(index, 1);
          }
        });
    },
    onGeminiModelChange(item) {
      item.endpoint = `https://generativelanguage.googleapis.com/v1beta/models/${item.model}:generateContent`;
    },
    AddGeminiTts() {      this.geminiTtsList.push({
        endpoint: "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-tts:generateContent",
        endpointLocked: true,
        location: "global",
        accessToken: "",
        showToken: false,
        model: "gemini-2.5-flash-preview-tts",
        voiceNameEn: null,
        voiceNameTh: null,
        voiceNameCn: null,
        instruction: "",
      });
    },
    DeleteGeminiTts(index) {
      this.$swal
        .fire({
          title: this.$t("confirmDeletion"),
          text: "Delete this Gemini TTS configuration?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.geminiTtsList.splice(index, 1);
          }
        });
    },
    AddSummaryAgent() {
      let self = this;
      let temp = {
        key: '',
        value: null,
      };
      self.summaryAgentList.push(temp);
    },
    DeleteSummaryAgent(index, item) {
      let self = this;
      self.$swal
        .fire({
          title: this.$t('confirmDeletion'),
          text: 'Delete this Summary Agent configuration?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.summaryAgentList.splice(index, 1);
          }
        });
    },
    AddOpenIDConnect(Provider) {
      let self = this;
      let instance = null;
      if (Provider == 'Microsoft') {
        instance = 'https://login.microsoftonline.com/';
      }
      let temp = {
        id: 0,
        provider: Provider,
        sso: false,
        ssoChat: false,
        instance: instance,
        domain: null,
        tenantId: null,
        clientId: null,
        callbackPath: null,
        clientSecret: null,
        apiScope: null,
        urlConfig: null,
      };
      self.setupOpenIDConnectList.push(temp);
    },
    GetSummaryAgents() {
      const defaultValue = [{ key: '', value: null }];

      this.$call.GetSummaryAgent(
        (dataResponse) => {
          if (dataResponse.status !== 0 || !dataResponse.data) {
            this.summaryAgentList = defaultValue;
            return;
          }

          if (!Array.isArray(dataResponse.data) || dataResponse.data.length === 0) {
            this.summaryAgentList = defaultValue;
            return;
          }

          this.summaryAgentList = dataResponse.data.map((item) => {
            const keys = Object.keys(item);

            if (keys.length === 0) {
              return { key: '', value: null };
            }

            const agentName = keys[0];
            return {
              key: agentName,
              value: item[agentName],
            };
          });
        },
        (errorResource) => {
          console.error(errorResource);
          this.summaryAgentList = defaultValue;
        }
      );
    },
    GetGPTModels() {
      let self = this;
      let request = {
        page: 1,
        perPage: 1000,
        modelName: null,
        modelDisplayId: null,
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableGPTModel(
        request,
        (dataResponse) => {
          if (dataResponse.status == 0 && dataResponse.data && dataResponse.data.data) {
            self.gptModelList = dataResponse.data.data.map((item) => {
              // Truncate modelName if longer than 30 characters
              const truncatedModelName = item.modelName && item.modelName.length > 30 ? item.modelName.substring(0, 30) + '...' : item.modelName;

              return {
                modelId: item.modelId,
                modelName: item.modelName,
                modelDisplay: item.modelDisplay,
                modelNameDisplay: item.modelNameDisplay,
                displayText: `#${item.modelDisplay} - ${truncatedModelName} (${item.modelNameDisplay})`,
              };
            });
          } else {
            self.gptModelList = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
          self.gptModelList = [];
        }
      );
    },
    async UpdateSummaryAgents() {
      let self = this;
      try {
        let validAgents = self.summaryAgentList.filter((item) => item.key && item.value);
        let apiFormat = validAgents.map((agent) => ({
          [agent.key]: agent.value,
        }));

        await new Promise((resolve, reject) => {
          self.$call.UpdateSummaryAgents(
            apiFormat,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                resolve(dataResponse);
              } else {
                reject(dataResponse);
              }
            },
            (error) => reject(error)
          );
        });
      } catch (error) {
        console.error('Error updating summary agents:', error);
        throw error;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async GetDDLModelDataAzureProvider() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLModelDataAzureProvider(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDModelShow = dataResponse.data;
          } else {
            self.DDModelShow = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async GetModelData() {
      let self = this;
      let req = {
        page: 1,
        perPage: 1000,
        sortDesc: false,
        sortBy: null,
      };
      try {
        await self.$call.GetModelData(
          req,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.modelDataList = dataResponse.data.data || [];
            } else {
              self.modelDataList = [];
            }
          },
          (errorResource) => {
            self.modelDataList = [];
            console.error(errorResource);
          }
        );
      } catch (error) {
        self.modelDataList = [];
        console.error(error);
      }
    },
    UpdateAIProcessingEndpointApiVersion(item) {
      let modelData = this.uniqueModelDataList.find((model) => model.modelName === item.deployment);
      item.apiVersion = modelData ? modelData.apiVersion : null;
    },
    NormalizeLegacyMaxTokensModels() {
      this.setup.legacyMaxTokensModels = [...new Set(this.setup.legacyMaxTokensModels || [])];
    },
  },
};
</script>

<style scoped>
.setup-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

.header-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.header-content {
  color: white;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 300;
  margin: 0;
  margin-bottom: 8px;
}

.page-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 24px;
}

.date-display {
  color: white;
  font-size: 1.1rem;
  opacity: 0.9;
}

.save-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white !important;
}

.config-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.config-card {
  border-radius: 16px !important;
  border: none;
  background: white;
  transition: all 0.3s ease;
  width: 100%;
}

.config-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

.card-header {
  background: linear-gradient(135deg, #0e81df 30%, #e2e8f0 100%);
  border-radius: 16px 16px 0 0 !important;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
}

.card-header .v-card__title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #495057;
}

.card-content {
  padding: 24px;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-title::before {
  content: '';
  width: 4px;
  height: 20px;
  background: #667eea;
  margin-right: 12px;
  border-radius: 2px;
}

.section-subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #6c757d;
  margin-bottom: 16px;
}

.endpoint-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid #e9ecef;
}

.priority-field {
  max-width: 120px;
}

.toggle-btn,
.delete-btn {
  background: rgba(108, 117, 125, 0.1) !important;
}

.add-endpoint-btn {
  color: #1867c0 !important;
  border: 2px dashed #1867c0 !important;
  background: transparent !important;
  border-radius: 12px;
  height: 56px;
  width: 100%;
  margin-top: 16px;
  transition: all 0.3s ease;
}

.add-endpoint-btn:hover {
  border-color: #667eea !important;
  background: rgba(102, 126, 234, 0.05) !important;
}

.storage-section {
  margin-bottom: 24px;
}

.service-tabs .v-tabs {
  border-radius: 12px;
  background: #f8f9fa;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.setting-item {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
}

.switch-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

/* คำอธิบายใต้สวิตช์ — ให้คนตั้งค่ารู้ผลของการเปิด/ปิดโดยไม่ต้องไปเปิดเอกสาร */
.setting-hint {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.5;
  color: #6c757d;
}

.modern-switch .v-input__slot {
  background: transparent !important;
}

.loading-card {
  border-radius: 16px !important;
  text-align: center;
}

.loading-text {
  font-size: 1.1rem;
  color: #495057;
  font-weight: 500;
}

/* Form field styling */
.v-text-field--outlined {
  border-radius: 12px;
}

.v-text-field--outlined .v-input__control .v-input__slot {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.v-text-field--outlined.v-input--is-focused .v-input__control .v-input__slot {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .header-section {
    flex-direction: column;
    text-align: center;
    gap: 24px;
  }

  .header-actions {
    flex-direction: column;
    gap: 16px;
  }

  .page-title {
    font-size: 2rem;
  }
}

@media (max-width: 600px) {
  .setup-container .v-container {
    padding: 16px;
  }

  .header-section {
    padding: 24px;
  }

  .config-card {
    margin-bottom: 16px;
  }

  .card-content {
    padding: 16px;
  }
}
.save-action-card {
  /* background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%) !important; */
  border: 1px solid rgba(24, 103, 192, 0.12);
  border-radius: 16px !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 0 0 rgba(24, 103, 192, 0.15) !important;
}

.save-action-content {
  padding: 20px 24px !important;
}

.save-action-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.save-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.save-text {
  display: flex;
  flex-direction: column;
}

.save-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1867c0;
  margin: 0;
  line-height: 1.2;
}

.save-subtitle {
  font-size: 0.875rem;
  color: #6c757d;
  margin: 2px 0 0 0;
  line-height: 1.3;
}

.save-action-button {
  min-width: 200px !important;
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.save-action-button:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(24, 192, 60, 0.35) !important;
}

.save-action-button:active {
  transform: translateY(0) !important;
}

.save-action-button .v-btn__prepend {
  margin-right: 8px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .save-action-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .save-info {
    justify-content: center;
    text-align: center;
  }

  .save-action-button {
    width: 100%;
    min-width: unset !important;
  }
}

@media (max-width: 600px) {
  .save-action-content {
    padding: 16px 20px !important;
  }

  .save-title {
    font-size: 1rem;
  }

  .save-subtitle {
    font-size: 0.8rem;
  }

  .save-action-button {
    height: 44px !important;
    font-size: 0.9rem !important;
  }

  .save-info .v-icon {
    display: none;
  }
}

/* Animation for better UX */
.save-action-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Loading state for save button */
.save-action-button.v-btn--loading {
  background: linear-gradient(135deg, #64b5f6 0%, #42a5f5 100%) !important;
}

.sticky-save-btn {
  position: fixed;
  top: 130px;
  right: 30px;
  z-index: 1000;
  max-width: 800px;
  box-shadow: 0px 6px 12px rgba(14, 87, 8, 0.4) !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

/* Animation เมื่อ sticky button ปรากฏ */
.sticky-save-btn {
  animation: slideInFromRight 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
}

/* Enhanced hover effect สำหรับ sticky button */
.sticky-save-btn:hover {
  transform: translateX(-5px) scale(1.02);
  box-shadow: 0px 12px 20px rgba(14, 69, 133, 0.5) !important;
}

/* Responsive สำหรับ sticky button */
@media (max-width: 960px) {
  .sticky-save-btn {
    width: 200px;
    right: 20px;
    top: 120px;
  }
}

@media (max-width: 600px) {
  .sticky-save-btn {
    width: 180px;
    right: 15px;
    top: 100px;
    font-size: 0.9rem !important;
  }
}

/* ซ่อน sticky button เมื่อ dialog เปิด */
.v-overlay--active ~ .setup-container .sticky-save-btn {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
</style>
